var $ = jQuery;
var selectedCurrentColor = "";
function get_cart_details(is_bundle = false) {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (data) {
      if (data.items.length == 0) {
        $(".non-empty-cart").hide();
        $("#CartDrawer-CartItems").html("");
        $(".empty-cart").show();
        $(".cart-drawer .shop-btn-header").show();
        $(".cart-drawer__form").hide();
        $(".cart-drawer .checkout-btn-header").hide();
        $(".cart-drawer #cartSubtotal").hide();
        $(".cart-drawer .empty-shop-btn").show();
        addon_products();
        if (!$(".empty-cart .cart-addon-products").length) {
          $(".non-empty-cart .cart-addon-products").appendTo(".empty-cart");
        }
      } else {
        $(".drawer__inner-empty").hide();
        $("cart-drawer.drawer").removeClass("is-empty");
        $("cart-drawer-items").removeClass("is-empty");
        $(".non-empty-cart").show();
        $(".empty-cart").hide();
        $(".cart-drawer__form").show();
        $(".cart-drawer .shop-btn-header").hide();
        $(".cart-drawer #cartSubtotal").show();
        $(".cart-drawer .empty-shop-btn").hide();
        set_cart_items(data.items);
        set_cart_bundle_item(data);
        console.log("cart data: ", data);
        console.log("length: ", data.items.length);

        let bundleTracker = {};
        let priceTracker = 0;
        data.items.forEach((item) => {
          console.log("data item: ", item);
          if (item.properties["_Bundle"] != undefined) {
            console.log("found a bundle: ", item.properties["_bid"], bundleTracker[item.properties["_bid"]]);
            if (bundleTracker[item.properties["_bid"]] == undefined) {
              console.log("is a bundle that hasn't been used");
              priceTracker = priceTracker + (Number(item.properties["_bundlePrice"]) * 100)
              bundleTracker[item.properties["_bid"]] = true;
            }
          } else {
            priceTracker = priceTracker + item.final_price
          }
          console.log("priceTracker while adding: ", priceTracker);
        });
        console.log("priceTracker: ", priceTracker);
        // if product has _Bundle property, get _bid to make sure it hasn't been evaluated, if not use bundle price and then evaluate further discounts.
        // else, add final_price

        set_cart_subtotal(priceTracker);
        addon_products();
        if (!$(".non-empty-cart .cart-addon-products").length) {
          $(".empty-cart .cart-addon-products").appendTo(".non-empty-cart");
        }
      }
      $("#CartDrawer-CartItems").removeClass("loading");
      set_cart_count(data);
      var subs = false;
      for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].handle.includes("-month-plan")) {
          subs = true;
        }
      }
      if (subs) {
        $("body").attr("data-subscription", true);
        $("#cartSubtotal .checkout-btn").addClass("sub__checkout");
        $("#cartSubtotal .checkout-btn").data("token", data.token);
      } else {
        $("#cartSubtotal .checkout-btn").removeClass("sub__checkout");
        $("body").removeAttr("data-subscription");
      }
      // add custom fuction for over $35 sale
      var enable_free_offer = $("#enable_free_offer").val();
      if (enable_free_offer == true || enable_free_offer == "true")
        addFreeItem(data);
    },
  });
  var set_cart_count = function (data) {
    var cart_count = 0;
    if (data.items.length > 0) {
      $.each(data.items, function (index, item) {
        cart_count = cart_count + item["quantity"];
      });
    }
    if (cart_count == 0) {
      $(".open-cart-drawer .cart_count").hide();
    } else {
      $(".open-cart-drawer .cart_count").show();
      $(".cart-count-bubble").text(cart_count);
    }
  };
  var set_cart_subtotal = function (price) {
    var target = $(".drawer__footer");
    var total_price = price / 100;
    // total_price=Math.round(total_price);
    total_price = total_price.toFixed(2);
    target.find(".totals__total-value").html("$" + total_price);

    if (parseInt(total_price) >= 35) {
      $(".bar-progress").css("width", "100%");
      if ($(".cart-drawer .bar-container").attr("data-country") == "US") {
        $(".cart-drawer .bar-container .bar-text p").text(
          "You qualify for free shipping!"
        );
        target.find(".shipping-text").text("FREE");
      } else {
        // $('.cart-drawer .bar-container .bar-text p').text('You qualify for a free Fine Toothbrush!');
      }
    } else {
      var percent = (total_price * 100) / 35;
      $(".bar-progress").css("width", percent + "%");
      if ($(".cart-drawer .bar-container").attr("data-country") == "US") {
        $(".cart-drawer .bar-container .bar-text p").text(
          "Add $" + (35 - total_price).toFixed(2) + " for free shipping"
        );
        target.find(".shipping-text").text("$5.00");
        var est_total_price = total_price * 1 + 5;
        est_total_price = est_total_price.toFixed(2);
        target.find(".totals__total-value").html("$" + est_total_price);
      } else {
        // $('.cart-drawer .bar-container .bar-text p').text('Add $'+(35-total_price)+' for a free Fine Toothbrush');
      }
    }
  };

  var set_cart_items = function (items) {
    console.log("cart items");
    console.log(items);
    // var target = $("#cartItems");
    var target = $("#CartDrawer-CartItems");
    var itemsDOM = "";
    $.each(items, function (index, item) {
      if (typeof item["properties"]["_Bundle"] == "undefined") {
        var line = items.indexOf(item) + 1;
        var itemDOM = "";
        var item_id = item["id"];
        var item_image = item["image"];
        var image_type = ".jpg";
        /*
        image_type = item_image.indexOf(".jpg") >= 0 ? ".jpg" : (item_image.indexOf(".jpeg") >= 0 ? ".jpeg" : (item_image.indexOf(".png") >= 0 ? ".png" : ""));
        item_image = item_image.split(image_type);
        if ($(window).width() > 767) {
          item_image = item_image[0] + "_x88" + image_type + item_image[1];
        } else {
          item_image = item_image[0] + image_type + item_image[1];
        }*/
        var item_price = item["price"];
        var item_final_line_price = item["final_line_price"];
        var item_price_total = item["price"] * item["quantity"];
        var item_quantity = item["quantity"];
        var item_title = item["product_title"];
        var item_variant = item["variant_title"];
        var item_handle = item["handle"];
        var item_url = get_url(item_handle);
        var subs_handle = item_handle;
        var option_value = item["options_with_values"][0]["name"];
        console.log("option_value: ", option_value);
        console.log("item data: ", item);
        if (subs_handle.indexOf("month") >= 0) {
          subs_handle = subs_handle.replace("3-month-plan-", "");
          subs_handle = subs_handle.replace("4-month-plan-", "");
          subs_handle = subs_handle.replace("6-month-plan-", "");
          console.log(subs_handle);
          switch (subs_handle) {
            case "body-scrubber":
              subs_handle = "flat-body-scrubber";
              break;
            case "":
              subs_handle = "flat-body-scrubber";
              break;
            case "replacement-head":
              handle = "original-replacement-head";
              break;
            default:
              "";
          }
        }
        item_price = item_price / 100;
        item_price_total = item_price_total / 100;
        item_price = item_price.toFixed(2);
        item_price_total = item_price_total.toFixed(2);
        item_final_line_price = item_final_line_price / 100;
        item_final_line_price = item_final_line_price.toFixed(2);
        const variantDOM = get_product_variants(item_handle, item_variant);
        // const variantDOM = get_product_variants(subs_handle, item_variant);
        // add discount label

        var priceDom = "$" + item_price_total;
        var discountDom = "";
        var itemClass = "";
        if (item["discounts"].length) {
          discountDom = '<ul class="discount-label">';
          $.each(item["discounts"], function (index, discount) {
            var dis_amt = discount.amount / 100;
            dis_amt = dis_amt.toFixed(2);
            var discount_icon =
              '<svg class="icon-svg icon-svg--color-adaptive-light icon-svg--size-16 reduction-code__icon remove-while-loading" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<g clip-path="url(#clip0_1362_21866)">' +
              '<path d="M15.2 5.74166C15.8627 5.74166 16.4 5.2044 16.4 4.54166C16.4 3.87892 15.8627 3.34166 15.2 3.34166C14.5373 3.34166 14 3.87892 14 4.54166C14 5.2044 14.5373 5.74166 15.2 5.74166Z" stroke="#231F20" stroke-linecap="round" stroke-linejoin="round"/>' +
              '<path d="M18.0833 0.624997H10.275C10.0986 0.626069 9.92428 0.662795 9.76245 0.732966C9.60063 0.803138 9.45466 0.905306 9.33333 1.03333L1 9.925C0.881443 10.0501 0.789478 10.1979 0.729665 10.3596C0.669851 10.5212 0.64343 10.6933 0.651998 10.8654C0.660566 11.0376 0.703945 11.2062 0.779514 11.3611C0.855083 11.516 0.961273 11.654 1.09167 11.7667L9.425 19.0583C9.67735 19.2781 10.0051 19.3914 10.3393 19.3743C10.6735 19.3572 10.9881 19.2111 11.2167 18.9667L19.025 10.6333C19.2499 10.3975 19.3752 10.0842 19.375 9.75833V1.90833C19.375 1.7391 19.3415 1.57153 19.2765 1.41529C19.2115 1.25904 19.1162 1.1172 18.9962 0.997917C18.8761 0.878639 18.7337 0.784284 18.577 0.720282C18.4203 0.656281 18.2526 0.623898 18.0833 0.624997Z" stroke="#231F20" stroke-linecap="round" stroke-linejoin="round"/>' +
              "</g>" +
              "<defs>" +
              '<clipPath id="clip0_1362_21866">' +
              '<rect width="20" height="20" fill="white"/>' +
              "</clipPath>" +
              "</defs>" +
              "</svg>";
            // var discount_icon = <svg class="icon-svg icon-svg--color-adaptive-light icon-svg--size-16 reduction-code__icon remove-while-loading" aria-hidden="true" focusable="false"> <use xlink:href="#tags-filled"></use> </svg>';
            discountDom +=
              '<li class="discount-code">' +
              discount_icon +
              discount.title +
              " (-$" +
              dis_amt +
              ")</li>";
          });
          discountDom += "</ul>";
          priceDom =
            discountDom +
            '<span class="original">$' +
            item_price_total +
            '</span><span class="discounted">$' +
            item_final_line_price +
            "</span>";
          // $.each(item['discounts'], function(index, discount){
          //   if (discount.title == 'FREE') {
          //     priceDom = 'FREE';
          //     itemClass = 'free-item';
          //   }
          // });
        }
        var inputDisabled = "";
        if ($(window).width() < 768) inputDisabled = " readonly";

        var removeItemDom =
          '<a class="cart-item-remove" href="javascript:" data-remove-id="' +
          item_id +
          '"></a>';
        if (item_title === "Gift Card") {
          itemDOM =
            '<div class="card cart-item ' +
            itemClass +
            '" data-key="' +
            item["key"] +
            '" data-variant-title="' +
            item["variant_title"] +
            '" data-handlee="' +
            item_handle +
            '" data-id="' +
            item_id +
            '" data-variant-id=' +
            item["variant_id"] +
            ' data-line="' +
            line +
            '" data-handle="' +
            item_handle +
            '">' +
            removeItemDom +
            '<div class="row g-0"><div class="col-md-4 col-3"><a href="' +
            item_url +
            "/?variant=" +
            item_id +
            '"><img class="cart-item-image" src="' +
            item_image +
            '" alt="' +
            item_title +
            '"></a></div><div class="col-md-6 col-6"><div class="card-body"><a href="' +
            item_url +
            "/?variant=" +
            item_id +
            '"><h4 class="cart-item-title">' +
            item_title +
            '</h4></a><p class="cart-item-variation">Amount USD: ' +
            item_variant +
            '</p><div class="cart-item-quantity-selector"><div class="input-group"> <span class="input-group-btn"> <a href="javascript:;" class="btn btn-default qt-btn-number" data-type="minus" data-field="quant[1]">-</a> </span> <input type="text" name="quant[1]" class="form-control input-number" value="' +
            item_quantity +
            '" min="0" max="1000" ' +
            inputDisabled +
            '> <span class="input-group-btn"> <a href="javascript:;" class="btn btn-default qt-btn-number" data-type="plus" data-field="quant[1]">+</a> </span></div></div><div class="cart-vt">' +
            variantDOM +
            '</div></div></div><div class="col-md-2 col-3 cart-item-actions">' +
            '<h4 class="cart-price">' +
            priceDom +
            "</h4><a class='cart-item-remove' href='javascript:'>Remove</a></div></div></div>";;
        } else {
          console.log("subscription item: ", item);
          if (item.hasOwnProperty("selling_plan_allocation")) {
            itemDOM =
              '<div class="card cart-item ' +
              itemClass +
              '" data-key="' +
              item["key"] +
              '" data-variant-title="' +
              item["variant_title"] +
              '" data-sellingplan="' +
              item["selling_plan_allocation"]["selling_plan"]["id"] +
              '" data-handlee="' +
              item_handle +
              '" data-id="' +
              item_id +
              '" data-variant-id=' +
              item["variant_id"] +
              ' data-line="' +
              line +
              '" data-handle="' +
              item_handle +
              '">' +
              removeItemDom +
              '<div class="row g-0"><a href="' +
              item_url +
              "/?variant=" +
              item_id +
              '"><h4 class="cart-item-title">' +
              item_title +
              '</h4></a><div class="col-md-4 col-3"><a href="' +
              item_url +
              "/?variant=" +
              item_id +
              '"><img class="cart-item-image" src="' +
              item_image +
              '" alt="' +
              item_title +
              '"></a></div><div class="col-md-6 col-6"><div class="card-body"><p class="cart-item-variation mb-0">' + option_value + ': ' +
              item_variant +
              '</p><p class="product-option mb-2">' +
              item["selling_plan_allocation"]["selling_plan"]["name"] +
              '</p><div class="cart-item-actions"><button type="button" class="btn btn-primary cart-item-edit" data-handle="' +
              item_handle +
              '"  style="display: block;">Edit</button><button type="button" class="btn btn-primary cart-item-done">Done</button></div><div class="cart-item-quantity-selector"><div class="input-group"> <span class="input-group-btn"> <a href="javascript:;" class="btn btn-default qt-btn-number" data-type="minus" data-field="quant[1]">-</a> </span> <input type="text" name="quant[1]" class="form-control input-number" value="' +
              item_quantity +
              '" min="0" max="1000" ' +
              inputDisabled +
              '> <span class="input-group-btn"> <a href="javascript:;" class="btn btn-default qt-btn-number" data-type="plus" data-field="quant[1]">+</a> </span></div></div><div class="cart-vt">' +
              variantDOM +
              '</div></div></div><div class="col-md-2 col-3 cart-item-actions"><h4 class="cart-price">' +
              priceDom +
              "</h4><a class='cart-item-remove' href='javascript:'>Remove</a></div></div></div>";
          } else {
            itemDOM =
              '<div class="card cart-item ' +
              itemClass +
              '" data-key="' +
              item["key"] +
              '" data-variant-title="' +
              item["variant_title"] +
              '" data-handlee="' +
              item_handle +
              '" data-id="' +
              item_id +
              '" data-variant-id=' +
              item["variant_id"] +
              ' data-line="' +
              line +
              '" data-handle="' +
              item_handle +
              '">' +
              removeItemDom +
              '<div class="row g-0"><a href="' +
              item_url +
              "/?variant=" +
              item_id +
              '"><h4 class="cart-item-title">' +
              item_title +
              '</h4></a><div class="col-md-4 col-3"><a href="' +
              item_url +
              "/?variant=" +
              item_id +
              '"><img class="cart-item-image" src="' +
              item_image +
              '" alt="' +
              item_title +
              '"></a></div><div class="col-md-6 col-6"><div class="card-body"><p class="cart-item-variation">' + option_value + ': ' +
              item_variant +
              '</p><div class="cart-item-actions"><button type="button" class="btn btn-primary cart-item-edit" data-handle="' +
              item_handle +
              '" style="display: block;">Edit</button><button type="button" class="btn btn-primary cart-item-done">Done</button></div><div class="cart-item-quantity-selector"><div class="input-group"> <span class="input-group-btn"> <a href="javascript:;" class="btn btn-default qt-btn-number" data-type="minus" data-field="quant[1]">-</a> </span> <input type="text" name="quant[1]" class="form-control input-number" value="' +
              item_quantity +
              '" min="0" max="1000" ' +
              inputDisabled +
              '> <span class="input-group-btn"> <a href="javascript:;" class="btn btn-default qt-btn-number" data-type="plus" data-field="quant[1]">+</a> </span></div></div><div class="cart-vt">' +
              variantDOM +
              '</div></div></div><div class="col-md-2 col-3"><h4 class="cart-price">' +
              priceDom +
              "</h4><a class='cart-item-remove' href='javascript:'>Remove</a></div></div></div>";
          }
        }

        itemsDOM += itemDOM;
      }
    });
    target.html("");
    target.html(itemsDOM);
    $("");
  };
}
function subscribe_product(
  handle,
  variant,
  quantity,
  sub_value,
  sellingPlan,
  product_id,
  variation
) {
  $.getJSON("/products/" + handle + ".js", function (product) {
    var subscribe_variants = product["variants"];
    // console.log(subscribe_variants);return false;
    $.each(subscribe_variants, function (index, subscribe_variant) {
      if (subscribe_variant["title"].toLowerCase() == variant.toLowerCase()) {
        var variant_id = subscribe_variant["id"];
        var random_number_subs = Math.floor(Math.random() * 90000) + 10000;

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: quantity,
            id: variation,
            selling_plan: sellingPlan,
            form_type: "product" /*
              "properties[shipping_interval_frequency]": "12",
              "properties[shipping_interval_unit_type]": "months"*/,
          },
          dataType: "json",
          success: function (data) {
            get_cart_details();
            $(".cart-drawer").addClass("active");
            $("cart-drawer").addClass("active");
            get_cart_details();
          },
        });
      }
    });
  });
}

function update_plan_selection(plan) {
  $(plan).each(function () {
    if ($(this).data("varqty") == true) {
      var swatchCon = $(this).data("title");
      $(".hr-colors .swatch .swatch-element").each(function () {
        if ($(this).data("color") == swatchCon) {
          $(this).attr("data-available", true);
          // $(this).find('.product_swatch').attr('data-soldout', false);
        }
      });
    } else {
      var swatchCon = $(this).data("title");
      $(".hr-colors .swatch .swatch-element").each(function () {
        if ($(this).data("color") == swatchCon) {
          $(this).attr("data-available", false);
          // $(this).find('.product_swatch').attr('data-soldout', false);
        }
      });
    }
  });
  update_color_stock();
}
function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

function counterControl(target, number, config) {
  var _target = target;
  var number = number.toString();
  var numArray = number.split("");
  var isBg = false;
  var defaults = {
    speed: 2000,
    isDigitBg: false,
    comma: true,
  };
  $.extend(defaults, config);

  _target.empty();
  _target.html('<span class="pplNum"></span>');

  for (var i = 0; i < numArray.length; i++) {
    var html = "";
    numArray[i] = parseInt(numArray[i], 10);
    if (defaults.isDigitBg) {
      html =
        '<span class="digit-con"><span class="digit' + i + '"></span></span>';
    } else {
      html =
        '<span class="digit-con"><span class="digit' +
        i +
        '">0<br>1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br>0<br>1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br></span></span>';
    }
    _target.find(".pplNum").append(html);
  }

  if (defaults.comma) {
    _target
      .find(".digit-con:nth-last-child(3n+4)")
      .after("<span class='comma'>,</a>");
  }

  checkScroll();

  $(window).bind("scroll", function () {
    checkScroll();
  });

  function checkScroll() {
    if (_target.offset().top < $(window).scrollTop() + $(window).height()) {
      for (var i = 0; i < numArray.length; i++) {
        var increment = _target.find(".digit-con").outerHeight();
        _target
          .find(".digit" + i)
          .delay(i * 300)
          .animate(
            { top: -(increment * numArray[i] + increment * 10) },
            defaults.speed,
            "linear"
          );
      }
    }
  }
}

function makeid() {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 8; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}
function get_product_variants(handle, item_variant, bundlehandle = "") {
  localStorage.removeItem(bundlehandle + "cartItemVariants-" + handle);
  if (bundlehandle) {
    var bundlehandle = bundlehandle + "-";
  }
  $.getJSON("/products/" + handle + ".js", function (product) {
    let swatches = "";
    const product_id = product["id"];
    const product_variants = product["variants"];
    const pv = [];
    const colors = ["Black", "Blue", "Pink", "Red", "Mint", "Yellow"];
    $.each(colors, function (index, color) {
      $.each(product_variants, function (index, variant) {
        if (color === variant["title"]) {
          pv.push(variant);
        }
      });
    });

    $.each(pv, function (index, variant) {
      var unique = makeid();
      if (variant["available"]) {
        const variant_id = variant["id"];
        const variant_color = variant["title"];
        const color = variant_color.toLowerCase();
        var variant_image = variant["featured_image"]["src"];
        if ($(window).width() > 767) {
          if (variant_image.indexOf(".jpg") >= 0) {
            variant_image = variant_image.replace(".jpg", ".jpg");
          }
          if (variant_image.indexOf(".png") >= 0) {
            variant_image = variant_image.replace(".png", ".png");
          }
        }
        let checked = item_variant === variant_color ? "checked" : "";
        swatches =
          swatches +
          '<div class="swatch-color" id="' +
          bundlehandle +
          "cartItemVariantId-" +
          variant_id +
          '"><input type="radio" name="' +
          bundlehandle +
          "cart-item-option-" +
          product_id +
          '" class="swatch_cartitem_radio swatches variation" id="' +
          bundlehandle +
          "swatch-cartitem-" +
          unique +
          "-" +
          variant_id +
          '" value="' +
          variant_id +
          '"  data-img="' +
          variant_image +
          '" ' +
          checked +
          '><label for="' +
          bundlehandle +
          "swatch-cartitem-" +
          unique +
          "-" +
          variant_id +
          '" class="swatch-label bg-' +
          color +
          '">' +
          variant_color +
          "</label></div>";
      }
    });
    localStorage.setItem(
      bundlehandle + "cartItemVariants-" + handle,
      '<div class="cartItemVariantOptions">' + swatches + "</div>"
    );
    // if ($('#CartDrawer-CartItems .cart-item.free-item').length && handle == $('#CartDrawer-CartItems .cart-item.free-item').attr("data-handle")) {
    //   const vd = localStorage.getItem("cartItemVariants-" + $('#CartDrawer-CartItems .cart-item.free-item').attr("data-handle"));
    //   $('#CartDrawer-CartItems .cart-item.free-item .cart-vt').html(vd);
    // }
  });
  return localStorage.getItem(bundlehandle + "cartItemVariants-" + handle) ===
    null
    ? ""
    : localStorage.getItem(bundlehandle + "cartItemVariants-" + handle);
}
function handleize(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}
// Update Cart
function update_cart_items_by_key(key, quantity) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      quantity: quantity,
      id: key,
    },
    dataType: "json",
    success: function (data) {
      get_cart_details();
    },
  });
}
function update_cart_items(line, quantity) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      quantity: quantity,
      line: line,
    },
    dataType: "json",
    success: function (data) {
      get_cart_details();
    },
  });
}
// Add bundle to cart
function add_bundle_items(bundleItems) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: bundleItems,
    },
    dataType: "json",
    success: function (data) {
      get_cart_details();
      $(".cart-drawer").addClass("active");
      $("cart-drawer").addClass("active");
      get_cart_details();
    },
  });
}
function remove_and_update_bundle_items(removebundleItems, bundleItems) {
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: removebundleItems,
    dataType: "json",
    success: function () {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: bundleItems,
        },
        dataType: "json",
        success: function () {
          get_cart_details();
          $(".cart-drawer").addClass("active");
          $("cart-drawer").addClass("active");
        },
      });
    },
  });
}
function update_color_stock() {
  if (
    $(".template-product .product__info-wrapper  .hr-colors .swatch").length > 0
  ) {
    $(
      ".template-product .product__info-wrapper  .hr-colors .swatch .swatch-element input:checked"
    ).each(function () {
      $(this).click();
    });
  }
}
function update_bundle_items(data) {
  console.log(data);
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: data,
    dataType: "json",
    success: function (data) {
      get_cart_details();
    },
  });
}
function updateBackground(templateClass, product, color) {
  if (product === "flat-body-scrubber" || product === "loop-body-scrubber") {
    $("#ColorForGradient-body-scrubber").val(color);
  } else {
    $("#ColorForGradient-" + product).val(color);
  }

  let bgtemp = "";
  let bgmain = "";
  $(".ForGradient").each(function () {
    let gradient = $(this).val();
    bgtemp += "," + gradient;
    bgmain += "," + gradient + "99";
  });

  let bgcolor, bgmaincolor;
  if ($(window).width() > 1100) {
    bgcolor = "linear-gradient(to right" + bgtemp + ")";
    bgmaincolor = "linear-gradient(to right" + bgmain + ")";
  } else if ($(window).width() < 768) {
    bgcolor = "linear-gradient(45deg" + bgtemp + ")";
    bgmaincolor = "linear-gradient(45deg" + bgmain + ")";
  } else {
    bgcolor = "linear-gradient(135deg" + bgtemp + ")";
    bgmaincolor = "linear-gradient(135deg" + bgmain + ")";
  }

  $(templateClass).css({
    background: bgcolor,
    "padding-top": "125px", // replace 'value' with the desired padding-top value, e.g., '20px'
    "margin-top": "-125px", // replace 'value' with the desired margin-top value, e.g., '10px'
  });
  // $('main').css('background', bgmaincolor);
}

function handleOutOfStock(element, parent_target) {
  parent_target.addClass("prason");
  element
    .closest(".bp-wrapper")
    .find(".bundle-add-to-basket-new")
    .prop("disabled", true);

  element
    .closest(".hr-colors")
    .addClass("bc-oos")
    .find(".bundle-color-out-of-stock")
    .show();
  parent_target.find(".add-to-cart").hide();
  parent_target.find(".join-waitlist.not-available").show();
  parent_target.find(".bundle-out-of-stock").show();
  parent_target.find(".join-waitlist__wrapper:not(.show)").addClass("show");
}

function handleInStock(element, parent_target) {
  element
    .closest(".hr-colors")
    .removeClass("bc-oos")
    .find(".bundle-color-out-of-stock")
    .hide();
  parent_target.find(".add-to-cart").show();
  element
    .closest(".bp-wrapper")
    .find(".bundle-add-to-basket-new")
    .prop("disabled", false);

  parent_target.find(".join-waitlist.not-available").hide();
  parent_target.find(".bundle-out-of-stock").hide();
  parent_target.find(".join-waitlist__wrapper.show").removeClass("show");

  if ($(".hr-colors.active_bundle.bc-oos").length > 0) {
    parent_target.find(".add-to-cart").hide();
    parent_target.find(".join-waitlist.not-available").show();
    parent_target.find(".bundle-out-of-stock").show();
    parent_target.find(".join-waitlist__wrapper:not(.show)").addClass("show");
  }
}

function updatePreviewImage(slider_handle, slider_id) {
  let preview_img, fineb;
  fineb = $("#" + slider_id + " .carousel-item.active img").attr("src");
  if ($(window).width() > 767) {
    if (fineb.indexOf(".jpg") >= 0) {
      fineb = fineb.replace(".jpg", "_x106.jpg");
    }
    if (fineb.indexOf(".png") >= 0) {
      fineb = fineb.replace(".png", "_x106.png");
    }
  }

  if ($("body").hasClass("template-new_body_bundle")) {
    preview_img = "#preview-" + slider_handle;
  } else if (
    slider_handle == "flat-body-scrubber" ||
    slider_handle == "loop-body-scrubber"
  ) {
    preview_img = "#preview-body-scrubber";
  } else {
    preview_img = "#preview-" + slider_handle;
  }
  $(preview_img + " img").attr("src", fineb);
}

function handleTabToggle(element, prod_name) {
  if (element.hasClass("active_tab")) {
    element
      .removeClass("active_tab")
      .find(".minus-tab")
      .removeClass("active_tab");
    element.find(".plus-tab").addClass("active_tab");
    element
      .siblings("#" + prod_name + "-description-1")
      .find(".tab_product_desc")
      .slideUp()
      .removeClass("active_tab");
    element.siblings(".tab_product_desc").slideUp().removeClass("active_tab");
  } else {
    $(".tags-based-products-info .desktop-only")
      .removeClass("active_tab")
      .find(".minus-tab")
      .removeClass("active_tab");
    $(".tags-based-products-info .desktop-only")
      .find(".plus-tab")
      .addClass("active_tab");
    $(".tags-based-products-info .tab_product_desc")
      .slideUp()
      .removeClass("active_tab");

    element.addClass("active_tab").find(".minus-tab").addClass("active_tab");
    element.find(".plus-tab").removeClass("active_tab");
    element
      .siblings("#" + prod_name + "-description-1")
      .find(".tab_product_desc")
      .slideDown()
      .addClass("active_tab");
    element.siblings(".tab_product_desc").slideDown().addClass("active_tab");
  }
}
function addCommas(x) {
  if (x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
}

var update_cart = function (remove_item, add_item) {
  console.log("update_cart -> add_item: ", add_item);
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: remove_item,
    dataType: "json",
    success: function () {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: add_item,
        dataType: "json",
        success: function () {
          get_cart_details();
          // get_cart_details();
        },
      });
    },
  });
};
// Cart Addon
var addon_products = function () {
  $(".addon-item").removeClass("not-allowed");
  $(".addon-item").show();
  const cart_items = $("#CartDrawer-CartItems .cart-item");
  const first_cart_item = cart_items.first().attr("data-handle");
  console.log("FIRST CART ITEM" + first_cart_item);
  var default_items_prod = [
    "hook",
    "face-scrubber",
    "fine-toothbrush",
    "flat-body-scrubber",
    "loop-body-scrubber",
  ];
  var default_replacement_prod = [
    "fine-replacement-head",
    "original-replacement-head",
  ];
  var default_extra_prod = ["original-toothbrush"];
  var default_last_prod = false;
  $.each(cart_items, function (index, cart_item) {
    var def_handle = $(this).attr("data-handle");
    if (def_handle == "original-toothbrush") {
      default_last_prod = true;
    }
    if (def_handle.indexOf("month") >= 0) {
      def_handle = def_handle.replace("3-month-plan-", "");
      def_handle = def_handle.replace("4-month-plan-", "");
      def_handle = def_handle.replace("6-month-plan-", "");
      console.log(def_handle);
      switch (def_handle) {
        case "body-scrubber":
          def_handle = "flat-body-scrubber";
          break;
        case "":
          def_handle = "flat-body-scrubber";
          break;
        case "replacement-head":
          def_handle = "original-replacement-head";
          break;
        default:
          "";
      }
    }
    var item_to_remove = default_items_prod.indexOf(def_handle);
    if (item_to_remove > -1) {
      default_items_prod.splice(item_to_remove, 1);
    }
    var item_to_remove_2 = default_replacement_prod.indexOf(def_handle);
    if (item_to_remove_2 > -1) {
      default_replacement_prod.splice(item_to_remove_2, 1);
    }
  });
  if (default_items_prod.length > 0) {
    var addons = [
      "hook",
      "face-scrubber",
      "fine-toothbrush",
      "flat-body-scrubber",
      "loop-body-scrubber",
    ];
  } else if (
    default_replacement_prod.length > 0 &&
    default_items_prod.length == 0
  ) {
    var addons = ["fine-replacement-head", "original-replacement-head"];
  } else if (default_last_prod) {
    var addons = [];
    $("#addon-original-toothbrush").hide();
  } else {
    var addons = ["original-toothbrush"];
  }
  // console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT")

  // switch (first_cart_item){
  //   case "flat-body-scrubber":
  //     var addons = ["face-scrubber", "fine-toothbrush", "loop-body-scrubber", "original-toothbrush", "fine-replacement-head", "original-replacement-head"];
  //     break;
  //   case "loop-body-scrubber":
  //     var addons = ["face-scrubber", "fine-toothbrush", "flat-body-scrubber", "original-toothbrush", "fine-replacement-head", "original-replacement-head"];
  //     break;
  //   case "face-scrubber":
  //     var addons = [ "flat-body-scrubber", "fine-toothbrush", "loop-body-scrubber", "original-toothbrush", "fine-replacement-head", "original-replacement-head"];
  //     break;
  //   case "original-toothbrush":
  //     var addons = ["fine-replacement-head", "original-replacement-head", "flat-body-scrubber", "loop-body-scrubber","face-scrubber" ,"fine-toothbrush"];
  //     break;
  //   case "original-replacement-head":
  //     var addons = ["fine-toothbrush", "flat-body-scrubber", "face-scrubber", "loop-body-scrubber","fine-replacement-head" , "original-toothbrush"];
  //     break;
  //   case "fine-toothbrush":
  //     var addons = ["loop-body-scrubber","original-replacement-head", "fine-replacement-head","flat-body-scrubber",   "face-scrubber", "fine-toothbrush"];
  //     break;
  //   case "original-replacement-head":
  //     var addons = ["original-toothbrush","flat-body-scrubber", "face-scrubber", "loop-body-scrubber", "original-replacement-head", "fine-toothbrush"]
  //       break;
  //   default:
  //   var addons = ["face-scrubber", "fine-toothbrush" , "flat-body-scrubber", "loop-body-scrubber"];

  // }

  const _bundle_cart_items = $("#cartBundleItems .cart-item");
  const _bundle_cart_items_1 = $("#cartItemsSkinCareBundle .cart-item");
  const _bundle_cart_items_2 = $("#cartItemsOralCareBundle .cart-item");
  const _bundle_cart_items_3 = $("#cartItemsTheBodyBundle .cart-item");

  $.each(cart_items, function (index, cart_item) {
    const handle = $(this).attr("data-handle");
    $("#addon-" + handle).addClass("not-allowed");
    var item_to_remove = addons.indexOf(handle);
    if (item_to_remove > -1) {
      addons.splice(item_to_remove, 1);
    }
  });
  var addons_list = $(".cart-addon-products .addon-item:not(.not-allowed)");
  var addon_list_size = addons_list.length;
  // Target the element whose siblings you want to check
  var element = $(".cart-addon-products h3");

  // Check if any of the siblings are visible
  if (element.siblings(":visible").length > 0) {
    // At least one sibling is visible
    $(element).removeClass("hidden");
  } else {
    // No siblings are visible
    $(element).addClass("hidden");
    console.log("hide item");
  }

  // console.log("addons_list")
  //console.log(addons_list)
  //console.log(addons)
  if (addon_list_size > 0) {
    $(".cart-addon-products .addon-item").hide();
    // const rndInt = Math.floor(Math.random() * addon_list_size)
    $.each(addons_list, function (index) {
      // console.log(index, rndInt);
      // console.log(this)
      if (
        cart_items.length == 0 &&
        _bundle_cart_items.length == 0 &&
        _bundle_cart_items_1.length == 0 &&
        _bundle_cart_items_2.length == 0 &&
        _bundle_cart_items_3.length == 0
      ) {
        if (index < 2) {
          $(this).show();
        }
      } else {
        var item_to_show = addons[0];
        $("#addon-" + item_to_show).show();
      }
    });
  } else {
    $(".cart-addon-products .addon-item.not-allowed").hide();
  }

  // Target the element whose siblings you want to check
  var element = $(".cart-addon-products h3");

  // Check if any of the siblings are visible
  if (element.siblings(":visible").length > 0) {
    // At least one sibling is visible
    $(element).removeClass("hidden");
  } else {
    // No siblings are visible
    $(element).addClass("hidden");
    console.log("hide item");
  }
};

var get_url = function (handle) {
  if (handle.indexOf("month") >= 0) {
    handle = handle.replace("3-month-plan-", "");
    handle = handle.replace("4-month-plan-", "");
    handle = handle.replace("6-month-plan-", "");
    console.log(handle);
    switch (handle) {
      case "body-scrubber":
        handle = "flat-body-scrubber";
        break;
      case "":
        handle = "flat-body-scrubber";
        break;
      case "replacement-head":
        handle = "original-replacement-head";
        break;
      default:
        "";
    }
  }
  return "/products/" + handle;
};

var set_cart_bundle_item = function (cart) {
  var items = cart.items;
  var best_bundle = [];
  var hook_bundle = [];
  var skincare_bundle = [];
  var oralcare_bundle = [];
  var bodycare_bundle = [];
  var face_family_pack = [];
  var flat_family_pack = [];
  var loop_family_pack = [];
  var original_family_pack = [];
  var fine_family_pack = [];
  var hook_family_pack = [];
  var fine_head_family_pack = [];
  var original_head_family_pack = [];
  var bundleName = "";
  $.each(items, function (index, item) {
    // console.log(item["properties"]["Bundle"])
    if (typeof item["properties"]["_Bundle"] != "undefined") {
      item["line"] = items.indexOf(item) + 1;
      console.log(items.indexOf(item) + 1, "Lines");
      bundleName = item["properties"]["_Bundle"];

      best_bundle.push(item);

      /*
      if (item["properties"]["Bundle"] === "The Hook Bundle") {
        hook_bundle.push(item);
      }
      if (item["properties"]["Bundle"] === "Best Bundle") {
        best_bundle.push(item);
      }
      if (item["properties"]["Bundle"] === "Skin Care Bundle") {
        skincare_bundle.push(item);
      }
      if (item["properties"]["Bundle"] === "Oral Care Bundle") {
        oralcare_bundle.push(item);
      }
      if (item["properties"]["Bundle"] === "The Body Bundle") {
        bodycare_bundle.push(item);
      }
      if (item["properties"]["Bundle"] === "Face Scrubber Family Pack") {
        face_family_pack.push(item);
      }
      if (item["properties"]["Bundle"] === "Flat Body Scrubber Family Pack") {
        flat_family_pack.push(item);
      }
      if (item["properties"]["Bundle"] === "Loop Body Scrubber Family Pack") {
        loop_family_pack.push(item);
      }
      if (item["properties"]["Bundle"] === "Original Toothbrush Family Pack") {
        original_family_pack.push(item);
      }
      if (item["properties"]["Bundle"] === "Fine Toothbrush Family Pack") {
        fine_family_pack.push(item);
      }
      if (item["properties"]["Bundle"] === "Hook Family Pack") {
        hook_family_pack.push(item);
      }
      if (item["properties"]["Bundle"] === "Original Replacement Head Family Pack") {
        original_head_family_pack.push(item);
      }
      if (item["properties"]["Bundle"] === "Fine Replacement Head Family Pack") {
        fine_head_family_pack.push(item);
      }*/
    }
  });

  set_cart_bundle_dom(best_bundle, "cartBundleItems", bundleName);
  /* set_cart_bundle_dom(hook_bundle, 'cartHookBundleItems', "The Hook Bundle");
  set_cart_bundle_dom(skincare_bundle, 'cartItemsSkinCareBundle', "Skin Care Bundle");
  set_cart_bundle_dom(oralcare_bundle, 'cartItemsOralCareBundle', "Oral Care Bundle");
  set_cart_bundle_dom(bodycare_bundle, 'cartItemsTheBodyBundle', "The Body Bundle");
  set_cart_bundle_dom(face_family_pack, 'cartItemsFaceFamilyPack', "Face Scrubber Family Pack");
  set_cart_bundle_dom(flat_family_pack, 'cartItemsFlatFamilyPack', "Flat Body Scrubber Family Pack");
  set_cart_bundle_dom(loop_family_pack, 'cartItemsLoopFamilyPack', "Loop Body Scrubber Family Pack");
  set_cart_bundle_dom(original_family_pack, 'cartItemsOriginalFamilyPack', "Original Toothbrush Family Pack");
  set_cart_bundle_dom(fine_family_pack, 'cartItemsFineFamilyPack', "Fine Toothbrush Family Pack");
  set_cart_bundle_dom(hook_family_pack, 'cartItemsHookFamilyPack', "Hook Family Pack");
  set_cart_bundle_dom(original_head_family_pack, 'cartItemsOriginalheadFamilyPack', "Original Replacement Head Family Pack");
  set_cart_bundle_dom(fine_head_family_pack, 'cartItemsFineheadFamilyPack', "Fine Replacement Head Family Pack");*/
};
var set_cart_bundle_dom = function (items, id, bundle_type) {
  var target = $("#" + id);
  //  var target = $("#CartDrawer-CartItems");
  if (!items.length) {
    target.html("");
    return;
  }
  var itemsDOM = "";
  var bundle_original_total = 0;
  var bundle_discounted_total = 0;

  var productItemDom = "";
  var bundleCount = 0;
  var handle = handleize(bundle_type);
  var bundleId;
  let actualPrice;
  let bundleComparePrice = "";

  const groupedData = items.reduce((acc, cur) => {
    const bid = cur.properties._bid;
    if (!acc[bid]) {
      acc[bid] = [];
    }
    acc[bid].push(cur);
    return acc;
  }, {});
  // console.log('groupedData', Object.values(groupedData));
  var groupIdx = 0;
  $.each(groupedData, function (ind, items) {
    // console.log('gd', groupIdx);
    bundleId = items[0]["properties"]["_bid"];
    actualPrice = items[0]["properties"]["_actualPrice"];
    bundleComparePrice = items[0]["properties"]["_bundleComparePrice"];

    var bundleName = "";
    let bundlePrice = "";

    $.each(items, function (index, item) {
      bundleName = item["properties"]["_Bundle"];

      var product_quantity = item["quantity"];
      var item_original_price = product_quantity * item["original_price"];
      var item_discount_price = product_quantity * item["discounted_price"];
      bundleCount = bundleCount + product_quantity;
      console.log("bundle_original_total: ", bundle_original_total, ", item_original_price: ", item_original_price);
      bundle_original_total = bundle_original_total + item_original_price;
      bundle_discounted_total = bundle_discounted_total + item_discount_price;

      bundlePrice = item["properties"]["_bundlePrice"] * 100;
      let bundlePriceMoney = bundlePrice;
      let actualPrice = item["properties"]["_actualPrice"] * 100;

      console.log("bundlePriceMoney: ", bundlePriceMoney, ", bundlePrice: ", bundlePrice, "actual bundlePrice: ", item["properties"]["_bundlePrice"]);
      console.log("bundleComparePrice: ", bundleComparePrice);

      let totalDiscountPercent = (actualPrice - bundlePriceMoney) / actualPrice;
      let totalRemainig = 1 - totalDiscountPercent;
      bundle_discounted_total = bundlePriceMoney;

      var product_id = item["id"];
      var product_image = item["image"];
      if ($(window).width() > 767) {
        if (product_image.indexOf(".jpg") >= 0) {
          product_image = product_image.replace(".jpg", ".jpg");
        }
        if (product_image.indexOf(".png") >= 0) {
          product_image = product_image.replace(".png", ".png");
        }
      }

      var product_original_price = item_original_price;
      product_original_price = product_original_price / 100;
      product_original_price = product_original_price.toFixed(2);

      var product_discounted_price = item_original_price * totalRemainig;
      product_discounted_price = product_discounted_price / 100;
      product_discounted_price = product_discounted_price.toFixed(2);

      var product_title = item["product_title"];
      var product_variant = item["variant_title"];
      var product_handle = item["handle"];
      var line = item["line"];
      var key = item["key"];
      var item_url =
        "/products/" + product_handle + "/?variant=" + item["variant_id"];
      let variantDOM = get_product_variants(
        product_handle,
        product_variant,
        handle
      );
      if (item_discount_price == 0) {
        product_item =
          '<div class="card cart-item" data-bundleComparePrice="' +
          bundleComparePrice +
          '" data-bundlePrice="' +
          bundlePrice +
          '" data-actualPrice="' +
          actualPrice +
          '" data-bid="' +
          bundleId +
          '" data-key=' +
          key +
          ' id="bundle-' +
          product_id +
          '" data-handlee="' +
          product_handle +
          '"  data-bundle="true" data-id="' +
          product_id +
          '" data-line="' +
          line +
          '" data-qty="' +
          product_quantity +
          '" data-type="' +
          bundle_type +
          '"> <div class="row g-0"><a href="' +
          item_url +
          '"><h4 class="cart-item-title">' +
          product_title +
          '</h4></a> <div class="col-md-4 col-3"><a href="' +
          item_url +
          '"> <img class="cart-item-image" src="' +
          product_image +
          '" alt="' +
          product_title +
          "-" +
          product_variant +
          '"></a> </div><div class="col-md-6 col-6"> <div class="card-body">  <p class="cart-item-variation">Color: ' +
          product_variant +
          '</p><div class="cart-vt">' +
          variantDOM +
          '</div><h4 class="cart-price">FREE</h4> </div></div><div class="col-md-2 col-3 cart-item-actions"> <button type="button" class="btn btn-primary cart-item-edit" data-handle="' +
          product_handle +
          '" style="display: block;">EDIT</button> <button type="button" class="btn btn-primary cart-item-done" >DONE</button> </div></div></div>';
      } else {
        product_item =
          '<div class="card cart-item"  data-bundleComparePrice="' +
          bundleComparePrice +
          '" data-bundlePrice="' +
          bundlePrice +
          '" data-actualPrice="' +
          actualPrice +
          '" data-bid="' +
          bundleId +
          '" data-key=' +
          key +
          ' id="bundle-' +
          product_id +
          '" data-handlee="' +
          product_handle +
          '"  data-bundle="true" data-id="' +
          product_id +
          '" data-line="' +
          line +
          '" data-qty="' +
          product_quantity +
          '" data-type="' +
          bundle_type +
          '"> <div class="row g-0"> <div class="col-md-4 col-3"><a href="' +
          item_url +
          '"> <img class="cart-item-image" src="' +
          product_image +
          '" alt="' +
          product_title +
          "-" +
          product_variant +
          '"></a> </div><div class="col-md-6 col-6"> <div class="card-body"> <a href="' +
          item_url +
          '"><h4 class="cart-item-title">' +
          product_title +
          '</h4></a> <p class="cart-item-variation">Color: ' +
          product_variant +
          '</p><button type="button" class="btn btn-primary cart-item-edit" data-handle="' +
          product_handle +
          '"  style="display: block;">Edit</button> <button type="button" class="btn btn-primary cart-item-done" >Done</button> <div class="cart-vt">' +
          variantDOM +
          '</div><h4 class="cart-price"> <span class="original">$' +
          product_original_price +
          '</span> <span class="discounted">$' +
          product_discounted_price +
          '</span> </h4> </div></div></div></div>';
      }
      productItemDom = productItemDom + product_item;
    });
    if (bundleCount > 0) {
      console.log("bundle_original_total: ", bundle_original_total);
      bundle_original_total = bundle_original_total / 100;
      bundle_original_total = bundle_original_total.toFixed(2);
      bundle_discounted_total = bundle_discounted_total / 100;
      // bundle_discounted_total=Math.round(bundle_discounted_total);
      bundle_discounted_total = Math.round(bundle_discounted_total).toFixed(2);
      bundle_title = bundleName;

      /*if (id == "cartHookBundleItems") {
        bundle_title = "The Hook Bundle";
      }
      if (id == "cartItemsSkinCareBundle") {
        bundle_title = "Skin Care Bundle";
      }
      if (id == "cartItemsOralCareBundle") {
        bundle_title = "Oral Care Bundle";
      }
      if (id == "cartItemsTheBodyBundle") {
        bundle_title = "The Body Bundle";
      }
      if (id == "cartItemsFineFamilyPack") {
        bundle_title = "Fine Toothbrush Family Pack";
      }
      if (id == "cartItemsOriginalFamilyPack") {
        bundle_title = "Original Toothbrush Family Pack";
      }
      if (id == "cartItemsLoopFamilyPack") {
        bundle_title = "Loop Body Scrubber Family Pack";
      }
      if (id == "cartItemsFlatFamilyPack") {
        bundle_title = "Flat Body Scrubber Family Pack";
      }
      if (id == "cartItemsFaceFamilyPack") {
        bundle_title = "Face Scrubber Family Pack";
      }
      if (id == "cartItemsHookFamilyPack") {
        bundle_title = "Hook Family Pack";
      }
      if (id == "cartItemsFineheadFamilyPack") {
        bundle_title = "Fine Replacement Head Family Pack";
      }
      if (id == "cartItemsOriginalheadFamilyPack") {
        bundle_title = "Original Replacement Head Family Pack";
      }
*/
      var itemBundleHeader =
        '<div class="card cart-bundle-heading" ><h4 class="cart-item-title">Bundle</h4> <div class="row g-0"> <div class="col-md-9 col-9"> <h4 class="bundle-subtitle"> ' +
        bundle_title +
        " </h4> <p>includes " +
        bundleCount +
        ' items</p></div><div class="col-3 cart-header-actions"> <h4 class="cart-price float-end"> <span class="original">$' +
        Number(bundleComparePrice).toFixed(2) +
        '</span> <span class="discounted">$' +
        (bundlePrice / 100).toFixed(2) +
        "</span> <a class='cart-item-remove' href='javascript:' data-bid='" +
        bundleId +
        "' data-remove-id='" +
        id +
        "'>Remove</a></h4></div></div></div>";
      itemsDOM = itemBundleHeader + productItemDom;
    }

    if (groupIdx == 0) {
      console.log("first draw");
      target.html("");
      target.html(itemsDOM);
    } else {
      console.log("elsedraw");
      target.append(itemsDOM);
    }
    itemsDOM = "";
    bundle_original_total = 0;
    bundle_discounted_total = 0;

    productItemDom = "";
    bundleCount = 0;

    groupIdx++;
  });
};

var product_variation_image = function (image, target) {
  console.log(target.find(".product-image"));
  target.find(".product-image").show();
  target.find(".card_custom_available").remove();

  target.find(".product-image").attr("src", image);
  target.find(".product-image").attr("srcset", image);
};
var product_variation_url = function (url, target) {
  if ($(target).find("a").attr("href").includes("/products")) {
    target
      .find("a:not('.join-waitlist'):not('.overview-cross')")
      .attr("href", url);
  }
};
var product_variation_price = function (price, target) {
  target.find("span.price-item.price-item--regular").html(price);
};
var product_basket_button = function (id, target) {
  target.find(".add-to-basket").attr("data-id", id);
};
var product_waitlist = function (
  id,
  soldout,
  target,
  product_id,
  product_name
) {
  if (soldout == "true") {
    var waitlist_button = target.find(".join-waitlist");
    waitlist_button.attr("data-product-id", product_id);
    waitlist_button.attr("data-variation-id", id);
    waitlist_button.attr("data-product-title", product_name);
    target.find(".add-to-basket").hide();
    target.find(".join-waitlist").show();
    target.find(".out-of-stock-label").show();
  } else {
    target.find(".add-to-basket").show();
    target.find(".join-waitlist").hide();
    target.find(".out-of-stock-label").hide();
  }
};
$(document).ready(function () {
  const faqs_wrapper = $(".faqs-page");
  const quick_guide_wrapper = $(".quick-guide-content");
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom
      ? $(this).attr("id")
      : "";
  };
  if (quick_guide_wrapper) {
    $(".fixed-sidebar .desktop-only a:nth-child(1)").addClass("active_current");
  }

  if (window.pageYOffset > 400) {
    $(".buttons-sticky").addClass("show");
  }
  if (window.pageYOffset > 100) {
    $("#top-navbar").addClass("fixed");
  } else {
    $("#top-navbar").removeClass("fixed");
  }
  $(window).on("scroll", function () {
    if (window.pageYOffset > 70) {
      $("#top-navbar").addClass("fixed");
    } else {
      $("#top-navbar").removeClass("fixed");
    }
    if (window.pageYOffset > 400) {
      $(".buttons-sticky").addClass("show");
    } else {
      $(".buttons-sticky").removeClass("show");
    }
    if (faqs_wrapper != "undefined") {
      var in_view = "";
      var faqs_in_view = [];
      $(".faqs-header").each(function () {
        if ($(this).isInViewport()) {
          in_view = $(this).attr("id");
          faqs_in_view.push(in_view);
        }
      });

      $("#sticky-sidebar li a button").removeClass("active");
      $(".sticky-" + faqs_in_view[0])
        .find("a button")
        .addClass("active");
      if (
        $(window).innerHeight() + $(window).scrollTop() >=
        $("body").height()
      ) {
        if ($(window).height() > 1300) {
          $("#sticky-sidebar li a button").removeClass("active");
          $("#sticky-sidebar li:last-child a button").addClass("active");
        }
      }
    }

    if (quick_guide_wrapper != "undefined") {
      var in_view = "";
      var quick_in_view = [];
      $(".quick-guide > div").each(function () {
        if (
          $(this).isInViewport() &&
          $(this).offset().top - $(window).scrollTop() - 121 < 80
        ) {
          in_view = $(this).attr("id");
          quick_in_view.push(in_view);
        }
      });
      if (quick_in_view.length > 0) {
        $(".fixed-sidebar > .desktop-only a").removeClass("active_current");
      }
      $(".fixed-sidebar > .desktop-only")
        .find('a[href*="#' + quick_in_view[quick_in_view.length - 1] + '"]')
        .addClass("active_current");
    }
    // if(parseInt($(window).scrollTop() + $(window).height())== $(document).height()) {
    $("html").css("padding-bottom", "0px");
    // }
  });
  $(".goto_url_class").on("click", function () {
    var got_check = $(this);
    $(this).closest(".nav-item").find(".dropdown-menu").css("display", "none");
    $(got_check).closest(".nav-link.dropdown-toggle").dropdown("hide");
    $(got_check).closest(".nav-link.dropdown-toggle").stop();
    setInterval(function () {
      $(got_check).closest(".nav-link.dropdown-toggle").dropdown("hide");
    }, 1);

    window.location = $(this).attr("data-url");
  });

  $(".nav-item.has-megamenu").on("mouseenter", function () {
    $(this).find(".nav-link.dropdown-toggle").addClass("show");
    $(".dropdown-menu.megamenu").removeClass("show");
    $(this).find(".dropdown-menu.megamenu").addClass("show");
  });
  $(".dropdown-menu.megamenu").on("mouseleave", function () {
    $(this).removeClass("show");
  });

  // Product Card

  $(document).on("click", "overview-toggle", function () {
    var product_card_id = $(this).closest(".product-card").attr("id");
    $("#" + product_card_id)
      .find(".product-overview")
      .show();
  });

  $(document).on("click", "overview-cross", function () {
    var product_card_id = $(this).closest(".product-card").attr("id");
    $("#" + product_card_id)
      .find(".product-overview")
      .hide();
  });

  var product_variation_info_card = function (
    info,
    bgColor,
    fontColor,
    target
  ) {
    console.log(target.find(".product-image"));
    target.find(".card__media .media .card_custom_available").remove();
    target.find(".product-image").hide();
    if (
      target.find(".card__media .media .card_custom_available").length === 0
    ) {
      // Split the 'info' text into words and wrap each word in a span
      const words = info.split(" ");
      const formattedInfo = words
        .map((word) => `<span>${word}</span>`)
        .join(" ");

      // Prepend the formatted content to the target container
      target
        .find(".card__media .media")
        .prepend(
          '<div class="card_custom_available" style="background:' +
          bgColor +
          ";color:" +
          fontColor +
          ';">' +
          formattedInfo +
          "</div>"
        );
    }
  };
  $(document).on("click", "product-card input.swatches", function () {
    var variation_image = $(this).attr("data-img");
    let availability = $(this).attr("data-availability");
    var bgColor = $(this).attr("data-bgColor");
    var info = $(this).attr("data-info");
    var fontColor = $(this).attr("data-fontColor");

    var variation_url = $(this).attr("data-url");
    var variation_price = $(this).attr("data-price");
    var variation_id = $(this).val();
    var product_id = $(this).attr("data-product-id");
    var product_name = $(this).attr("data-product-name");
    var variation_soldout = $(this).attr("data-soldout");
    var target = $(this).closest(".product-card-wrapper");
    var btnEle = target.find("#quick-add-form--submit");

    if (availability === "true") {
      btnEle.prop("disabled", false);
      product_variation_image(variation_image, target);
    } else {
      btnEle.prop("disabled", true);
      if (bgColor != "" && info != "") {
        console.log("show card");
        product_variation_info_card(info, bgColor, fontColor, target);
      }
    }
    product_variation_url(variation_url, target);
    product_variation_price(variation_price, target);
    product_basket_button(variation_id, target);
    product_waitlist(
      variation_id,
      variation_soldout,
      target,
      product_id,
      product_name
    );
  });

  $(function () {
    function evaluateThumbnails(clickedItem) {
      var color = $(clickedItem).val();
      selectedCurrentColor = color;
      $(".thumbnail-list__item").each(function () {
        var slideColor = $(this).attr("data-color");
        slideColor = slideColor == "All" ? color : slideColor;
        if (slideColor == "") {
          $(this).attr("data-color", color);
          slideColor = color;
        }
        // console.log("color: ", color, ", slideColor: ", slideColor);
        if (slideColor == color) {
          $(this).css("display", "list-item");
        } else {
          $(this).css("display", "none");
        }
      });

      $('.product__media-list.slider--mobile .slider__slide').each(function () {
        var slideColor = $(this).attr("data-color");
        var shownSlide = 0;
        slideColor = slideColor == "All" ? color : slideColor;
        if (slideColor == "") {
          $(this).attr("data-color", color);
          slideColor = color;
        }
        // console.log("color: ", color, ", slideColor: ", slideColor);
        if (window.innerWidth <= 749) {
          if (slideColor == color) {
            $(this).css("display", "block");
          } else {
            $(this).css("display", "none");
          }
        }
      });
    }
    $(".swatches").on("click", function () {
      evaluateThumbnails(this);
    });
    window.addEventListener('resize', (event) => {
      // Code to execute when the window is resized
      $(".product__info-container .swatches:checked").trigger("click");
      console.log('Window resized');
    });
    $(".product__info-container .swatches:checked").trigger("click");
  });

  $(document).on(
    "click",
    "product-info input.swatches, product-info .swatches-label",
    function () {
      var target = $(this).closest(".product__info-container");

      var target_media = $(this).closest(".product--thumbnail_slider");
      // Find the form within the container
      var form = target.find("form");
      var title = target.find(".product__title");

      // Retrieve the id and product-id from the hidden input fields
      var variant_id = form.find("input[name='id']").val();
      var product_id = form.find("input[name='product-id']").val();

      var product_title = title.find("h1").text();

      var is_available = $(this).attr("data-available");
      var bgColor = $(this).attr("data-bgColor");
      var info = $(this).attr("data-info");
      var fontColor = $(this).attr("data-fontColor");

      // Function to check variant availability

      // var parent_target = $(this).closest(".product__info-container");
      target.find(".add-to-basket").attr("data-id", variant_id);
      var out_of_stock_color = $(this).attr("data-color");

      var selected_radio_id = $(this).attr("id");
      var color_code = $("label[for='" + selected_radio_id + "']").css(
        "background-color"
      );
      var color = $("label[for='" + selected_radio_id + "']").attr("class");
      var text_color =
        color == "bg-pink" || color == "bg-yellow" ? "#231f20" : "#ffffff";

      // $(".buttons-sticky a").css("background-color", color_code);
      //$(".buttons-sticky a").css("color", text_color);
      if (is_available == "false" && info != "") {
        if (bgColor != "" && info != "") {
          target_media.find(".card_custom_available_pdp").remove();
          if (target_media.find(".card_custom_available_pdp").length === 0) {
            target_media
              .find("media-gallery")
              .prepend(
                '<div class="card_custom_available_pdp" style="background:' +
                bgColor +
                ";color:" +
                fontColor +
                ';">' +
                info +
                "</div>"
              );
          }

          product_variation_info_card(info, bgColor, fontColor, target_media);
        }
        target.find(".buy_subscription").hide();
        target.find(".add-to-basket").hide();
        target.find(".join-waitlist.not-available").show();
        console.log("show toggled off");
        target.find(".join-waitlist__wrapper:not(.show)").addClass("show");
        target.find(".out-of-stock-text").show();
        target.find(".join-waitlist").attr("data-variation-id", variant_id);
        target.find(".join-waitlist").attr("data-product-id", product_id);
        target.find(".join-waitlist").attr("data-product-title", product_title);
        target.find(".quantity-with-buy-button .product-form__quantity").hide();

        $("#backorder_subscribe_klaviyo")
          .find(".backorder-select option:first")
          .text(out_of_stock_color);
        if ($(".template-product  .all_soldout_btn").length > 0) {
          $(".sticky-join-the-waitlist").html("SOLD OUT");
        } else {
          $(".sticky-join-the-waitlist").html("JOIN THE WAITLIST");
        }
        $(".sticky-join-the-waitlist").css("display", "block");
        $(".sticky-add-to-basket").hide();
      } else if (is_available == "false") {
        target_media.find(".card_custom_available_pdp").remove();
        target.find(".buy_subscription").hide();
        target.find(".add-to-basket").hide();
        target.find(".join-waitlist.not-available").show();
        console.log("show toggled only for false");
        target.find(".join-waitlist__wrapper:not(.show)").addClass("show");
        target.find(".out-of-stock-text").show();
        target.find(".quantity-with-buy-button .product-form__quantity").hide();
        $(".sticky-join-the-waitlist").show();
        $(".sticky-add-to-basket").hide();
        $('.waitlist-message').text('');
        $('.join-waitlist.button').text('Out of stock - notify me');
        $('.waitlist-message').hide();

      } else {
        target_media.find(".card_custom_available_pdp").remove();

        target.find(".buy_subscription").show();

        $(".sticky-join-the-waitlist").hide();
        $(".sticky-add-to-basket").show();
        target.find(".add-to-basket").css("display", "block");
        target.find(".join-waitlist.not-available").hide();
        console.log("show toggled again");
        target.find(".join-waitlist__wrapper").removeClass("show");
        target.find(".out-of-stock-text").hide();
        target.find(".quantity-with-buy-button .product-form__quantity").show();
        $('.waitlist-message').text('COMING SOON');
        $('.join-waitlist.button').text('Join the Waitlist');
      }
    }
  );

  $(document).on(
    "click",
    " .stamped-container .stamped-summary-actions-newreview",
    function () {
      if (
        $(
          ".template-product .stamped-container .stamped-content .new-review-form"
        ).hasClass("stamped-visible")
      ) {
        $(this).html("Cancel Review");
      } else {
        $(this).html("Write a Review");
      }
    }
  );
  $(document).on(
    "click",
    " .template-page  .tags-product-details .accordion-header",
    function () {
      if (!$(this).find(".accordion-button").hasClass("collapsed")) {
        var head_id = $(this).attr("id");
        $(this)
          .closest(".tags-product-details")
          .find(
            ".accordion-collapse.collapse:not([aria-labelledby=" +
            head_id +
            "])"
          )
          .collapse("hide");
      }
    }
  );
  //    Add On
  $(".swatch_addon_radio").on("click", function () {
    var variation_image = $(this).attr("data-img");
    var variation_url = $(this).attr("data-url");
    var variation_price = $(this).attr("data-price");
    var variation_id = $(this).val();
    var target = $(this).closest(".addon-item");

    console.log("variation_id-" + variation_id);
    addon_variation_image(variation_image, target);
    addon_variation_url(variation_url, target);
    addon_variation_price(variation_price, target);
    addon_basket_button(variation_id, target);
    addon_color_text(target);
  });

  var addon_variation_image = function (image, target) {
    target.find(".cart-item-image").attr("src", image);
  };
  var addon_variation_url = function (url, target) {
    target.find("a").attr("href", url);
  };
  var addon_variation_price = function (price, target) {
    target.find(".cart-item-title span").html(price);
  };
  var addon_basket_button = function (id, target) {
    target.find(".add-to-basket").attr("data-id", id);
  };
  var addon_color_text = function (target) {
    var selected_radio_id = target
      .find(".swatches input[type='radio']:checked")
      .attr("id");
    var variant_color = $("#" + selected_radio_id).attr("data-color");
    console.log(
      "target: ",
      target,
      ", variant_color: ",
      variant_color,
      ", selected_radio_id: ",
      selected_radio_id
    );
    target.find(".addon-selected-color span").text(variant_color);
  };

  //    Quantity Selector
  $(".qt-btn-number").click(function (e) {
    e.preventDefault();

    fieldName = $(this).attr("data-field");
    type = $(this).attr("data-type");
    var input = $("input[name='" + fieldName + "']");
    var currentVal = parseInt(input.val());
    var currentTotal = Number($('.cart-count-bubble').html());
    if (!isNaN(currentVal)) {
      if (type == "minus") {
        if (currentVal > input.attr("min")) {
          input.val(currentVal - 1).change();
          $(".cart-count-bubble").text(currentTotal - 1);
        }
        if (parseInt(input.val()) == input.attr("min")) {
          $(this).attr("disabled", true);
        }
      } else if (type == "plus") {
        if (currentVal < input.attr("max")) {
          input.val(currentVal + 1).change();
          $(".cart-count-bubble").text(currentTotal + 1);
        }
        if (parseInt(input.val()) == input.attr("max")) {
          $(this).attr("disabled", true);
        }
      }
    } else {
      input.val(0);
    }
  });
  $(".input-number").focusin(function () {
    $(this).data("oldValue", $(this).val());
  });
  $(".input-number").change(function () {
    minValue = parseInt($(this).attr("min"));
    maxValue = parseInt($(this).attr("max"));
    valueCurrent = parseInt($(this).val());

    name = $(this).attr("name");
    if (valueCurrent >= minValue) {
      $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr(
        "disabled"
      );
    } else {
      $(this).val($(this).data("oldValue"));
    }
    if (valueCurrent <= maxValue) {
      $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr(
        "disabled"
      );
    } else {
      $(this).val($(this).data("oldValue"));
    }
  });
  $(".input-number").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if (
      $.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  });
  //Waitlist Popup
  $(".join-waitlist-familyss").on("click", function (e) {
    console.log("rafun");
    e.preventDefault();
    var variants_all = "<option disabled selected>Select Color</option>";
    $("#waitlistModal").modal("show");
    var p_id = $(this).attr("data-product-id");
    var v_id = $(this).attr("data-variation-id");
    var p_name = $(this).attr("data-product-title");
    var target = $("#backorder_subscribe_klaviyo");
    target.find("#waitlist_product_id").val(p_id);
    target.find("#waitlist_variant_id").val(v_id);
    target.find("#waitlist_product_name").val(p_name);
    target.find(".wait-list-product").html(p_name);
    var out_of_stock_color = $(this).attr("data-color");
    if (out_of_stock_color == "all") {
      $(".img-btn.join-waitlist-family").each(function () {
        var vari_id = $(this).data("variation-id");
        var vari_color = $(this).data("color");
        variants_all =
          variants_all +
          '<option value="' +
          vari_id +
          '">' +
          vari_color +
          "</option>";
      });
      target.find(".backorder-select").html(variants_all);
    } else {
      target
        .find(".backorder-select")
        .html("<option>" + out_of_stock_color + "</option>");
    }
  });
  $(".input.backorder-select").change(function () {
    var newVal = $(this).val();
    $("#waitlist_variant_id").val(newVal);
  });

  $(".join-waitlist").on("click", function () {
    console.log("waitlist");

    $("#waitlistModal").modal("show");
    var parent_target = $(this).closest(".product-card");
    var selected_radio_id = parent_target
      .find(".swatches input[type='radio']:checked")
      .attr("id");
    var out_of_stock_color = $("label[for='" + selected_radio_id + "']").text();
    var p_id = $(this).attr("data-product-id");
    var v_id = $(this).attr("data-variation-id");
    var p_name = $(this).attr("data-product-title");
    var target = $("#backorder_subscribe_klaviyo");
    target.find("#waitlist_product_id").val(p_id);
    target.find("#waitlist_variant_id").val(v_id);
    target.find("#waitlist_product_name").val(p_name);
    target.find(".wait-list-product").html(p_name);
    console.log(out_of_stock_color);
    if (out_of_stock_color) {
      target.find(".backorder-select option:first").text(out_of_stock_color);
    }
  });
  $(".bundle-join-waitlist").on("click", function () {
    $("#waitlistModal").modal("show");
  });
  //Newsletter Popup
  $(".special-offer-ticket").on("click", function () {
    $("#newsletterModal").modal("show");
    $(this).hide();
  });

  $("#newsletterModal .close").click(function () {
    $("#newsletterModal").modal("hide");
    $(".special-offer-ticket").show();
  });
  $(".no-thanks").on("click", function () {
    $("#newsletterModal").modal("hide");
    $(".special-offer-ticket").show();
  });
  //Cart Drawer
  get_cart_details();
  $(".open-cart-drawer").on("click", function () {
    $(".cart-drawer").addClass("active");
    $("cart-drawer").addClass("active");
    $("#CartDrawer").css("opacity", "1");
    $("#CartDrawer.left .modal-content .modal-body").css("opacity", "0");
    get_cart_details();
    setTimeout(function () {
      $("#CartDrawer.left .modal-content .modal-body").css("opacity", "1");
    }, 1000);
  });
  $(".cross-cart-drawer").on("click", function () {
    $("#CartDrawer").modal("hide");
    $("#CartDrawer-CartItems .cartItemVariantOptions").hide();
    $("#CartDrawer-CartItems .cart-item-quantity-selector").show();
    $("#CartDrawer-CartItems .cart-item-actions .cart-item-done").hide();
    $("#CartDrawer-CartItems .cart-item-actions .cart-item-edit").hide();
  });
  $(document)
    .on(
      "mouseenter",
      "#CartDrawer-CartItems .card.cart-item",
      function (event) {
        // if($(this).find(".cart-item-done").css('display') == 'none')
        // {
        //   $(this).find(".cart-item-edit").show();
        // }
      }
    )
    .on("mouseleave", "#CartDrawer-CartItems .card.cart-item", function () {
      // $(this).find(".cart-item-edit").hide();
    });
  //Ajax Get Cart Details on Button Click
  //get_cart_details();
  //Ajax Add to Cart

  $(document).on("click", ".add-to-basket-list", function (e) {
    e.preventDefault();
    var variation = $(this)
      .closest("product-form")
      .find("input[name=id]")
      .val();

    var quantity = 1;

    var data = {
      quantity: quantity,
      id: variation,
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (data) {
        get_cart_details();
        $(".cart-drawer").addClass("active");
        $("cart-drawer").addClass("active");
        get_cart_details();
      },
      error: function (xhr, status, error) {
        console.error("Error adding to cart: ", status, error);
        // alert(
        //   "There was an issue adding the item to the cart. Please try again."
        // );
      },
    });
  });
  $(document).on("click", ".add-to-basket", function (e) {
    // e.preventDefault();
    var variation = $(this)
      .closest(".product__info-container")
      .find(".product-variant-id")
      .val();
    var sellingPlan = $(this).attr("data-sellingplan");

    var product_id = $(this)
      .closest(".product__info-container")
      .find(".product-id")
      .val();

    var quantity = $(this)
      .closest(".product__info-container")
      .find(".quantity__input")
      .val();
    var subscription = $(this)
      .closest(".product__info-container")
      .find(".yearly_selection_box");
    var subscription_type = $(this)
      .closest(".product__info-container")
      .find(".buy_subscription .yearly.option_selection")
      .hasClass("active");

    if (subscription_type) {
      var subscription_handle = subscription
        .find(".radio_selection.active")
        .attr("data-handle");

      var sub_value = subscription
        .find(".radio_selection.active")
        .attr("data-value");

      var selected_variant_id = $(this)
        .closest(".product__info-container")
        .find("input.swatches:checked")
        .attr("id");
      console.log("Selected variant ID:", selected_variant_id); // Corrected log statement

      // var selected_variant = $("label[for='" + selected_variant_id + "']").attr("class");
      //console.log("Selected variant class before replace:", selected_variant); // Added log statement for debugging
      var selected_variant = $(this)
        .closest(".product__info-container")
        .find("input.swatches:checked")
        .attr("value");

      // selected_variant = selected_variant.replace('bg-', '');

      //if (selected_variant) {
      //  selected_variant = selected_variant.replace('swatches-label ', ''); // Replace the swatches-label class part
      //  }
      console.log("Selected variant class after replace:", selected_variant); // Corrected log statement

      $("body").attr("data-subscription", true);
      subscribe_product(
        subscription_handle,
        selected_variant,
        quantity,
        sub_value,
        sellingPlan,
        product_id,
        variation
      );
    } else {
      var carttype = $(this).attr("data-carttype");
      var data = {
        quantity: quantity,
        id: variation,
      };
      if (carttype == "addon") {
        var variantid = $(this).attr("data-id");
        data = {
          quantity: 1,
          id: variantid,
        };
      }

      console.log(data);

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function (data) {
          get_cart_details();
          $(".cart-drawer").addClass("active");
          $("cart-drawer").addClass("active");
          get_cart_details();
        },
        error: function (xhr, status, error) {
          console.error("Error adding to cart: ", status, error);
          alert(
            "There was an issue adding the item to the cart. Please try again."
          );
        },
      });
    }
  });

  $(".bundle-add-to-basket").on("click", function (e) {
    e.preventDefault();
    var parent_target = $(this).closest(".slater-product__info");
    var target = parent_target.find(".bp-wrapper");
    var items = target.find(".tags-based-products-info");
    var bundle = target.attr("data-type");
    var bundleItems = [];
    var lastbundleItems = [];
    var bundleId = Date.now();
    items.each(function () {
      let r = "_" + (Math.random() + 1).toString(36).substring(7);
      var quantity = 1;
      if ($(this).hasClass("group-products")) {
        var group_product = $(".bundle_group_product:checked").attr(
          "data-product"
        );
        var variant_id = $("#" + group_product)
          .find("input:radio:checked")
          .val();
      } else {
        var variant_id = $(this).find("input:radio:checked").val();
      }
      bundleItems.push({
        quantity: quantity,
        id: variant_id,
        properties: { _Bundle: bundle, _key: r, _bid: bundleId },
      });
      lastbundleItems.push(variant_id);
    });

    if (bundle.indexOf("Best") >= 0) {
      localStorage.setItem("best", lastbundleItems);
    }
    if (bundle.indexOf("Skin") >= 0) {
      localStorage.setItem("skin", lastbundleItems);
    }
    if (bundle.indexOf("Oral") >= 0) {
      localStorage.setItem("oral", lastbundleItems);
    }
    if (bundle.indexOf("Body") >= 0) {
      localStorage.setItem("body", lastbundleItems);
    }
    if (bundle.indexOf("Hook") >= 0) {
      localStorage.setItem("hook", lastbundleItems);
    }
    add_bundle_items(bundleItems);
  });

  $(".bundle-add-to-basket-new").on("click", function (e) {
    e.preventDefault();
    var parent_target = $(this).closest(".bundle_product_box");
    var target = parent_target.find(".bp-wrapper");
    var items = target.find(".tags-based-products-info");
    var bundle = target.attr("data-type");
    const bundlePrice = $(this).attr("data-bundlePrice");
    const bundleComparePrice = $(this).attr("data-bundleComparePrice");
    const actualPrice = $(this).attr("data-actualPrice");

    var bundleItems = [];
    var lastbundleItems = [];
    var bundleId = Date.now();

    items.each(function () {
      let r = "_" + (Math.random() + 1).toString(36).substring(7);
      var quantity = 1;
      if ($(this).hasClass("group-products")) {
        var group_product = $(".bundle_group_product:checked").attr(
          "data-product"
        );
        var variant_id = $("#" + group_product)
          .find("input:radio:checked")
          .val();
      } else {
        var variant_id = $(this).find("input:radio:checked").val();
      }
      //  bundleItems.push({ quantity: quantity, id: variant_id, properties: { 'Bundle': bundle, '_key': r, '_bid': bundleId } });
      bundleItems.push({
        quantity: quantity,
        id: variant_id,
        properties: {
          _Bundle: bundle,
          _key: r,
          _bid: bundleId,
          _bundlePrice: bundlePrice,
          _bundleComparePrice: bundleComparePrice,
          _actualPrice: actualPrice,
        },
      });

      lastbundleItems.push(variant_id);
    });

    /*
  if (bundle.indexOf("Best") >= 0) {
    localStorage.setItem("best", lastbundleItems);
  }
  if (bundle.indexOf("Skin") >= 0) {
    localStorage.setItem("skin", lastbundleItems);
  }
  if (bundle.indexOf("Oral") >= 0) {
    localStorage.setItem("oral", lastbundleItems);
  }
  if (bundle.indexOf("Body") >= 0) {
    localStorage.setItem("body", lastbundleItems);
  }
  if (bundle.indexOf("Hook") >= 0) {
    localStorage.setItem("hook", lastbundleItems);
  }*/

    add_bundle_items(bundleItems);
  });

  // Product detail page
  $(".counter > button").on("click", function () {
    var counter_target = $(this).closest(".counter");
    var parent_target = $(this).closest(".product-buttons");
    var quantity = counter_target.find(".js-counter-quantity").val();
    if ($(this).hasClass("js-counter-add")) {
      quantity = parseInt(quantity) + 1;
    }
    if ($(this).hasClass("js-counter-remove")) {
      quantity = parseInt(quantity) - 1;
    }
    quantity = quantity > 0 ? quantity : 1;
    counter_target.find(".js-counter-quantity").val(quantity);
    parent_target.find(".add-to-basket").attr("data-quantity", quantity);
  });
  $(".js-counter-quantity").on("keyup", function () {
    var parent_target = $(this).closest(".product-buttons");
    var quantity = $(this).val();
    quantity = parseInt(quantity);
    if (!quantity || quantity < 1) {
      $(this).val(1);
    }
    parent_target.find(".add-to-basket").attr("data-quantity", $(this).val());
  });
  $("input[name=product_variant]").change(function () {
    var parent_target = $(".product__info-container ").find(".add-to-basket");
    var variantId = $("input[name=product_variant]:checked").val();
    parent_target.attr("data-id", variantId);
  });
  // Bundle Page
  $(".bundle_group_product").on("change", function () {
    if ($(this).is(":checked")) {
      var product_handle = $(this).attr("data-product");
      $("#" + product_handle).show();
      $("#" + product_handle + ".hr-colors").addClass("active_bundle");
      $("." + product_handle + "-slider").show();
      $("#" + product_handle + "-description").show();
      $("#" + product_handle + "-description-1").show();
      var unchecked_handle = $(".bundle_group_product:not(:checked)").attr(
        "data-product"
      );
      $("#" + unchecked_handle).hide();
      $("#" + unchecked_handle + ".hr-colors").removeClass("active_bundle");
      $("." + unchecked_handle + "-slider").hide();
      $("#" + unchecked_handle + "-description").hide();
      $("#" + unchecked_handle + "-description-1").hide();
      // keep the color of product
      var old_swatch_color = $("#" + unchecked_handle)
        .find("input[type=radio]:checked")
        .closest(".swatch-element")
        .attr("data-color");
      var new_active_swatch = $("#" + product_handle)
        .find("input[type=radio]:checked")
        .closest(".swatch-element");
      if (old_swatch_color != new_active_swatch.attr("data-color")) {
        $("#" + product_handle)
          .find(".swatch-element[data-color='" + old_swatch_color + "'] label")
          .trigger("click");
      }
      // $(this).closest(".bp-wrapper__container").find("h3.desktop-only").removeClass("active_tab");
      var rd_check = $("#" + product_handle)
        .find("input[type=radio]:checked")
        .closest(".swatch-element")
        .attr("data-available");
      console.log(rd_check);
      const parent_target = $("#" + product_handle).closest(
        ".slater-product__info"
      );
      if (rd_check == "false") {
        $("#" + product_handle).addClass("bc-oos");
        $("#" + product_handle)
          .find(".bundle-color-out-of-stock")
          .show();
        parent_target.find(".add-to-cart").hide();
        parent_target.find(".bundle-out-of-stock").show();
      } else {
        $("#" + product_handle).removeClass("bc-oos");
        $("#" + product_handle)
          .find(".bundle-color-out-of-stock")
          .hide();
        parent_target.find(".add-to-cart").show();
        parent_target.find(".bundle-out-of-stock").hide();
        if ($(".hr-colors.active_bundle.bc-oos").length > 0) {
          // $(this).closest(".hr-colors").addClass("bc-oos");
          // $(this).closest(".hr-colors").find(".bundle-color-out-of-stock").show();
          parent_target.find(".add-to-cart").hide();
          parent_target.find(".bundle-out-of-stock").show();
        } else {
          // $(this).closest(".hr-colors").removeClass("bc-oos");
          // $(this).closest(".hr-colors").find(".bundle-color-out-of-stock").hide();
          parent_target.find(".add-to-cart").show();
          parent_target.find(".bundle-out-of-stock").hide();
        }
      }
    }
  });

  $(document).on(
    "click",
    ".cart-item-remove",
    function (e) {
      e.preventDefault();
      var bundle_id = $(this).attr("data-bid");
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (data) {
          var items = data.items;
          var data = { updates: [] };
          $.each(items, function (line, item) {
            data.updates[line] = item["quantity"];
            if (item["properties"]["_bid"] == bundle_id) {
              data.updates[line] = parseInt(item["quantity"]) - 1;
            }
          });
          update_bundle_items(data);
        },
      });
    }
  );
  $(document).on("click", ".cart-item-edit", function () {
    //   $('.cartItemVariantOptions').html('');
    const _target = $(this).closest(".cart-item");
    var var_selected_id = $(_target).attr("data-variant-id");
    // $(_target).find(".cart-vt .swatch-color#cartItemVariantId-"+var_selected_id+" input").prop("checked",true)
    var is_bundle = _target.attr("data-bundle");
    var item_vr_dom = _target.find(".cart-vt").html();
    if (!item_vr_dom.length) {
      if (is_bundle) {
        const bundle_type = handleize(_target.attr("data-type"));
        const variantDOM = localStorage.getItem(
          bundle_type + "-cartItemVariants-" + $(this).attr("data-handle")
        );
        _target.find(".cart-vt").html(variantDOM);
      } else {
        $(".cart-item:not(.free-item) .cart-vt").html(""); // $(".cart-vt").html('');
        const variantDOM = localStorage.getItem(
          "cartItemVariants-" + $(this).attr("data-handle")
        );
        _target.find(".cart-vt").html(variantDOM);
      }
    }
    const check_family = _target.attr("data-type");
    if (check_family) {
      if (check_family.indexOf("Family Pack") >= 0) {
        const family_type = handleize(_target.attr("data-type"));
        $(".cart-item:not(.free-item) .cart-vt").html(""); //$(".cart-vt").html('');
        const variantDOM = localStorage.getItem(
          family_type + "-cartItemVariants-" + $(this).attr("data-handle")
        );
        _target.find(".cart-vt").html(variantDOM);
      }
    }

    $(".cart-item").removeClass("edit-mode");
    // $(".cart-item").find(".cart-item-done").hide();
    // $(".cart-item").find(".cart-item-edit").removeAttr("style")
    // $(".cart-item").find(".cartItemVariantOptions").hide();
    if (is_bundle) {
      const bundle_type = handleize(_target.attr("data-type"));
      const variantDOM = localStorage.getItem(
        bundle_type + "-cartItemVariants-" + $(this).attr("data-handle")
      );
      $(".cart-item:not(.free-item) .cart-vt").html(""); //$(".cart-vt").html('');
      _target.find(".cart-vt").html(variantDOM);
      $(".cart-item").find(".cart-item-variation").show();
      var_selected_id = $(_target).attr("data-id");
      if (
        $(_target).find(
          ".cart-vt .swatch-color  input[value='" + var_selected_id + "']"
        ).length > 0
      ) {
        $(_target)
          .find(
            ".cart-vt .swatch-color  input[value='" + var_selected_id + "']"
          )
          .prop("checked", true);
      }
    } else {
      $(".cart-item").find(".cart-item-quantity-selector").show();
      if (
        $(_target).find(
          ".cart-vt .swatch-color#cartItemVariantId-" +
          var_selected_id +
          " input"
        ).length > 0
      ) {
        $(_target)
          .find(
            ".cart-vt .swatch-color#cartItemVariantId-" +
            var_selected_id +
            " input"
          )
          .prop("checked", true);
      }
    }
    const target = jQuery(this).closest(".cart-item");
    target.addClass("edit-mode");
    const variation_id = target.attr("data-id");
    const sellingplan = target.attr("data-sellingplan");
    target.find(".cart-item-done").show();
    target.find(".cart-item-done").attr("data-variant-id", variation_id);
    target.find(".cart-item-done").attr("data-sellingplan", sellingplan);

    // check if the original product variant is available or not
    if ($(this).attr("data-handle").includes("month-plan")) {
      var org_product = $(this).attr("data-handle").split("month-plan-")[1];
      switch (org_product) {
        case "body-scrubber":
          org_product = "flat-body-scrubber";
          break;
        case "":
          org_product = "flat-body-scrubber";
          break;
        case "replacement-head":
          org_product = "original-replacement-head";
          break;
        default:
          "";
      }
      var bg_color_arr = [];
      $(
        ".card.addon-item#addon-" + org_product + " .swatches .swatch-color"
      ).each(function () {
        bg_color_arr.push($(this).find("label.swatch-label").text());
      });
      target.find(".cartItemVariantOptions .swatch-color").each(function () {
        if (bg_color_arr.includes($(this).find("label.swatch-label").text()))
          $(this).show();
        else $(this).hide();
      });
    }
    //
    target.find(".cartItemVariantOptions").show();

    $(this).hide();
    // var is_bundle = target.attr("data-bundle");

    if (is_bundle) {
      target.find(".cart-item-variation").hide();
    } else {
      target.find(".cart-item-quantity-selector").hide();
    }
  });
  $(document).on("click", ".swatch_cartitem_radio", function (e) {
    $(this).prop("checked", true);
    //e.preventDefault();
    var product_image = $(this).attr("data-img");
    var variant_id = $(this).val();
    var var_name = $(this).siblings(".swatch-label").html();
    const target = jQuery(this).closest(".cart-item");

    target.find(".cart-item-image").attr("src", product_image);
    target.find(".cart-item-variation").html("Color: " + var_name);
    target.find(".cart-item-done").attr("data-variant-id", variant_id);
    if (target.hasClass("free-item")) target.find(".cart-item-done").click();
  });
  $(document).on("click", ".cart-item-done", function (e) {
    $("#CartDrawer-CartItems").addClass("loading");
    const target = jQuery(this).closest(".cart-item");
    var remove_variant_id = target.attr("data-line");
    var variant_id = $(this).attr("data-variant-id");
    var default_variant_id = target.attr("data-id");
    var qty = 1;
    if (variant_id === default_variant_id) {
      // qty = parseInt(target.attr("data-qty"));
      qty = parseInt(
        target.find(".card-body .cart-item-quantity-selector input").val()
      );
    }
    qty = parseInt(
      target.find(".card-body .cart-item-quantity-selector input").val()
    );
    target.removeClass("edit-mode");
    const remove_data = { quantity: 0, line: remove_variant_id };
    var is_bundle = target.attr("data-bundle");
    // var add_data = { quantity: 1, id: variant_id };
    var add_data = { quantity: qty, id: variant_id };

    var sellingplan = target.attr("data-sellingplan");
    if (sellingplan != "") {
      add_data = {
        quantity: qty,
        id: variant_id,
        selling_plan: sellingplan,
        form_type: "product",
      };
    }

    if (is_bundle) {
      qty = parseInt(target.attr("data-qty"));
      const bundle = target.attr("data-type");
      const bundleId = target.attr("data-bid");
      let bundlePrice = Number(target.attr("data-bundlePrice")) / 100;
      let bundleComparePrice = target.attr("data-bundleComparePrice");
      let actualPrice = target.attr("data-actualPrice");

      add_data = {
        quantity: qty,
        id: variant_id,
        properties: {
          _Bundle: bundle,
          _bid: bundleId,
          _bundlePrice: bundlePrice,
          _bundleComparePrice: bundleComparePrice,
          _actualPrice: actualPrice,
        },
      };
    }
    if (target.hasClass("free-item")) {
      add_data = {
        quantity: 1,
        id: variant_id,
        properties: { "Free Item": "FTB" },
      };
    }
    console.log("remove_data: ", remove_data, ", add_data: ", add_data);
    update_cart(remove_data, add_data);
  });

  $(document).on(
    "keyup",
    ".cart-item-quantity-selector .input-number",
    function (e) {
      if (e.keyCode == 13) {
        var counter_target = jQuery(this).closest(
          ".cart-item-quantity-selector"
        );
        var item_target = jQuery(this).closest(".cart-item");
        // var variant_id = item_target.attr("data-id");
        var line = item_target.attr("data-line");
        var quantity = counter_target.find(".input-number").val();

        update_cart_items(line, quantity);
      }
    }
  );
  $(document).on(
    "click",
    ".cart-item-quantity-selector .qt-btn-number",
    function ($) {
      var button = jQuery(this).attr("data-type");
      var counter_target = jQuery(this).closest(".cart-item-quantity-selector");
      var item_target = jQuery(this).closest(".cart-item");
      // var variant_id = item_target.attr("data-id");
      var line = item_target.attr("data-line");
      var key = item_target.attr("data-key");
      var quantity = counter_target.find(".input-number").val();

      if (button == "minus") {
        quantity = parseInt(quantity) - 1;
      }
      if (button == "plus") {
        quantity = parseInt(quantity) + 1;
      }
      if (quantity > 0) {
        counter_target.find(".input-number").val(quantity);
      }
      // update_cart_items(line, quantity);
      update_cart_items_by_key(key, quantity);
    }
  );
  $(document).on(
    "click,keyup",
    ".addon-item-quantity-selector .qt-btn-number",
    function (e) {
      e.preventDefault();

      var $button = $(this);
      var fieldName = $button.attr("data-field");
      var type = $button.attr("data-type");
      var $input = $button
        .closest(".input-group")
        .find("input[name='" + fieldName + "']");
      var currentVal = parseInt($input.val());

      if (!isNaN(currentVal)) {
        if (type === "minus") {
          // Ensure the value doesn't go below 1
          if (currentVal > 1) {
            $input.val(currentVal - 1); // Decrement by 1
          }
        } else if (type === "plus") {
          // Increment value if it's less than the max value
          if (currentVal < parseInt($input.attr("max"))) {
            $input.val(currentVal + 1); // Increment by 1
          }
        }
      } else {
        // If the input is not a number, set it to the default value of 1
        $input.val(1);
      }
    }
  );

  // Prevent manual entry of values below 1 in the input field
  $(document).on(
    "input",
    ".addon-item-quantity-selector .input-number",
    function () {
      this.value = this.value.replace(/[^0-9]/g, ""); // Allow only numbers
      if (this.value < 1 || this.value === "") {
        this.value = 1; // Reset to 1 if below 1
      }
    }
  );

  if ($(".product-card .product-options .swatches").length > 0) {
    $(
      ".product-card .product-options .swatches .swatch-color input:checked"
    ).each(function () {
      $(this).click();
    });
  }

  if ($(".tags-product-details .tags-based-products-info .swatch").length > 0) {
    // console.log("TESTTTTTTTTTTTTTTTTTTTTTTTTTTTTT")
    // $(".tags-product-details .tags-based-products-info .swatch .swatch-element input:checked").each(function(){
    //     $(this).click();
    //     $(this).change();
    // })
    $(".tags-product-details .tags-based-products-info .swatch").each(
      function () {
        // $($(this).find(".swatch-element input")[0]).click()
        var avail = false;
        $(this)
          .find(".swatch-element input")
          .each(function () {
            if (
              $(this).closest(".swatch-element").data("available") &&
              !avail
            ) {
              $(this).click();
              avail = true;
            }
          });
      }
    );
    setTimeout(function () {
      if ($(".template-page .slater-product__info .soldout-btn").length > 0) {
        $(
          ".tags-product-details .tags-based-products-info .swatch .swatch-element input:checked"
        ).trigger("change");
      }
    }, 200);
  }
  update_color_stock();

  // Subscription
});
// function get_subscribe_product(handle){
//     $.getJSON('/products/' + handle + '.js', function(product) {
//       });
// }

$(window).on("load", function () {
  var reviews_count = $(".stamped-summary-text").attr("data-count");
  if (reviews_count) {
    var count_with_comma = numberWithCommas(reviews_count);
    $(".stamped-summary-text").text(
      "Based on " + count_with_comma + " Reviews"
    );
  }
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
});
// Get started steps

// $('.template-standalone .product__info-wrapper .selection_box .month_selection').on('change',function(){
//   var sub_val = $(this).val();
//   $('.product__info-wrapper .selection_box .radio_selection').removeClass('active');
//   $('.product__info-wrapper .selection_box .radio_selection[data-value="'+sub_val+'"]').addClass('active');
// });

$(document).ready(function () {
  $(".template-product .quick-guide-content .fixed-sidebar a").on(
    "click",
    function (event) {
      event.preventDefault();
      var selectedHref = $(this).attr("href"),
        target = $(selectedHref);

      if ($(window).width() < 768) {
        // Uncomment and modify the following lines as needed
        /*
        faqsContainer.scrollTop(0).addClass('slide-in').children('ul').removeClass('selected').end().children(selectedHref).addClass('selected');
        closeFaqsContainer.addClass('move-left');
        $('body').addClass('cd-overlay');
        */
      } else {
        $("body,html").animate({ scrollTop: target.offset().top - 125 }, 200);
      }
    }
  );

  $(".buy_subscription .option_selection").on("click", function () {
    var isOneTimeSubscription = $(this).hasClass("one_time"),
      isYearlySubscription = $(this).hasClass("yearly"),
      planValue;

    $(this).addClass("active");

    if (isYearlySubscription) {
      $(".buy_subscription .option_selection.one_time").removeClass("active");
      $(".yearly_selection_box").show();
      var subscriptionHandle = $(".yearly_selection_box")
        .find(".selection_box .radio_selection:first")
        .data("handle");
      planValue = $(".month_selection").find(":selected").data("price");
      var monthlyPlan = $(".yearly_selection_box")
        .find(".selection_box .radio_selection.active")
        .data("value");
      // var vari = "." + monthlyPlan + "_month";
      // update_plan_selection(vari);
    }

    if (isOneTimeSubscription) {
      $(".buy_subscription .option_selection.yearly").removeClass("active");
      $(".yearly_selection_box").hide();
      planValue = $(this).data("price");
      // var vari = ".regular_prod";
      // update_plan_selection(vari);
    }

    $(".product-price").html(planValue);
  });

  $(".yearly_selection_box .selection_box .radio_selection").on(
    "click",
    function () {
      var $this = $(this),
        monthlyPlan = $this.data("value"),
        subscriptionHandle = $this.data("handle"),
        saveText = $this.data("savetext");

      $(".yearly_selection_box .selection_box .radio_selection").removeClass(
        "active"
      );
      $this.addClass("active");

      if ($("body").hasClass("template-standalone")) {
        var saveTextHelpHead = $this.data("head"),
          saveTextHelpDesc = $this.data("desc");
        $(
          ".yearly.option_selection .more-info .more-info-text .more-info-head"
        ).text(saveTextHelpHead);
        $(
          ".yearly.option_selection .more-info .more-info-text .more-info-desc"
        ).text(saveTextHelpDesc);
      }

      $(".yearly.option_selection span").text(saveText);
      $(".month_selection").val(monthlyPlan).trigger("change");
      var planValue = $(".month_selection").find(":selected").data("price");
      // get_subscribe_product(subscriptionHandle);
      $(".product-price").html(planValue);
      var shipmentCount = 12 / parseInt(monthlyPlan);
      $(".shipment-count").text("1");
    }
  );

  // Bundle Slider image Variation
  $(".bp-wrapper__container .swatch input[type=radio]").on(
    "change",
    function () {
      const target = $(this).closest(".swatch");
      const slider_handle = target.attr("data-target");
      const slider_id = "ProductCarousel" + slider_handle;
      // const variants = target.find("input:radio");

      var cs_var = $(this).attr("data-vcolor");
      // const selectedIndex = variants.index(variants.filter(':checked')) + 1;
      const carousel_target = $("#" + slider_id).find(".carousel-item");
      carousel_target.removeClass("active");

      $("#" + slider_id)
        .find(".carousel-item." + cs_var)
        .addClass("active");

      const _is_available = $(this)
        .closest(".swatch-element")
        .attr("data-available");
      const parent_target = $(this).closest(".bundle_product_box");
      console.log(_is_available);

      if (_is_available == "false") {
        // handleOutOfStock($(this), parent_target);
      } else {
        handleInStock($(this), parent_target);
      }

      updatePreviewImage(slider_handle, slider_id);

      // Change color name under the swatch
      const swatch_name =
        "color: " + $(this).closest(".swatch-element").data("color");
      $(this).closest(".swatch").find(".swatch-name").text(swatch_name);
      $("#preview-" + slider_handle + " .swatch-name").text(swatch_name);
      if (
        slider_handle == "flat-body-scrubber" ||
        slider_handle == "loop-body-scrubber"
      ) {
        $("#preview-body-scrubber .swatch-name").text(swatch_name);
      }
    }
  );

  // Product Slider image Variation
  $(".product__info-container .swatch input[type=radio]").on(
    "change",
    function () {
      const target = $(this).closest(".swatch");
      const slider_handle = target.attr("data-target");
      const slider_id = "productCarousel" + slider_handle;
      const variants = target.find("input:radio");
      const selectedIndex = variants.index(variants.filter(":checked")) + 1;
      const carousel_target = $("#" + slider_id).find(".carousel-item");
      carousel_target.removeClass("active");
      $("#" + slider_id)
        .find(".carousel-item:nth-child(" + selectedIndex + ")")
        .addClass("active");

      const slider_id_1 = "productCarouselModal" + slider_handle;
      const carousel_target_1 = $("#" + slider_id_1).find(".carousel-item");
      carousel_target_1.removeClass("active");
      $("#" + slider_id_1)
        .find(".carousel-item:nth-child(" + selectedIndex + ")")
        .addClass("active");
    }
  );

  // Handle account login/recover toggle
  if (window.location.href.includes("/login#recover")) {
    $(".account-login__recover").show();
    $(".account-login__login").hide();
  } else {
    $(".account-login__recover").hide();
    $(".account-login__login").show();
  }

  // Reset Password Button
  $("#reset-password-link").on("click", function () {
    $(".account-login__recover").show();
    $(".account-login__login").hide();
  });

  $("#login-link").on("click", function () {
    $(".account-login__recover").hide();
    $(".account-login__login").show();
  });

  // Handle tab toggle for tags-based products info
  $(".tags-based-products-info .desktop-only").on("click", function () {
    if ($(window).width() >= 768 && $(window).width() <= 1024) {
      const prod_name = $(this)
        .siblings(".bundle-group__selection")
        .find("ul li input:checked")
        .attr("data-product");
      handleTabToggle($(this), prod_name);
    }
  });

  var windowWidth = $(window).width();

  if (windowWidth < 767) {
    $(".quick-btn").on("click", function () {
      var id = $(this).attr("data-id");
      $(".quick-guide-content .quick-btn.open").each(function () {
        if ($(this).attr("data-id") != id) {
          $(this).toggleClass("open");
          var target2 =
            $(this).attr("data-id") === "reviews-mobile"
              ? $("." + $(this).attr("data-id"))
              : $("#" + $(this).attr("data-id"));
          target2.hide();
        }
      });
      $(this).toggleClass("open");
      var target = id === "reviews-mobile" ? $("." + id) : $("#" + id);
      if ($(this).hasClass("open")) {
        target.slideDown();
      } else {
        target.hide();
      }
    });

    var productBannerHeight = $(".product-banner").height();
    localStorage.setItem("product_banner_height", productBannerHeight);

    $(".txt-icon").on("click", function () {
      $(".txt-icon .block-description").css("opacity", 1).hide();
      $(this).toggleClass("open").siblings().removeClass("open");
      let pHeight = parseInt(localStorage.getItem("product_banner_height"));
      if ($(this).hasClass("open")) {
        var target = $(this).find(".block-description");
        target.show();
        var descriptionHeight = target.height() + 50;
        $(".product-banner").css("height", pHeight + descriptionHeight);
        target.css("opacity", 1);
      } else {
        $(this).find(".block-description").hide();
        $(".product-banner").css("height", pHeight);
      }
    });

    $(".faqs-page .mobile-only.faqs-opener").first().addClass("open");
    const firstFaq = $(".faqs-page .mobile-only.faqs-opener")
      .first()
      .attr("data-id");
    $(".faqs-type-" + firstFaq).show();
    $("#reviews-guide-id").remove();
    $(
      ".template-product .fixed-sidebar .mobile-only .faqs-title .quick-btn"
    ).addClass("open");
    $(".template-product .fixed-sidebar .mobile-only .quick-guide")
      .first()
      .show();
    $(
      ".bundle-quick-guide .fixed-sidebar .mobile-only .faqs-title .quick-btn"
    ).addClass("open");
    $(".bundle-quick-guide .fixed-sidebar .mobile-only .quick-guide")
      .first()
      .show();
    $(".product-banner-image .text-with-icons.mobile-only .txt-icon")
      .first()
      .addClass("open");
    $(".product-banner-image .text-with-icons.mobile-only .txt-icon")
      .first()
      .find(".block-description")
      .show()
      .css("opacity", 1);
    const iconHeight = parseInt(
      $(".product-banner-image .text-with-icons.mobile-only .txt-icon")
        .first()
        .find(".block-description")
        .css("height")
    );
    const bannerHeight = parseInt($(".product-banner-image").css("height"));
    $(".product-banner").css("height", iconHeight + bannerHeight);
  }

  $(
    ".slater-product__images .carousel, .pd-wrapper__images .carousel, .pd-wrapper__images-modal .carousel"
  ).carousel({
    pause: true,
    interval: false,
  });

  $(".slater-product__images .carousel-item").on("click", function () {
    var id = $(this).attr("data-id");
    var target = $(this).attr("data-bs-target");
    $(target)
      .find(".pd-wrapper__images-modal .carousel-item")
      .removeClass("active");
    $(target)
      .find(".pd-wrapper__images-modal .carousel-item[data-id='" + id + "']")
      .addClass("active");
  });

  $(".slater-product__images").on("slid.bs.carousel", function () {
    var id = $(this).find(".carousel-item.active").attr("data-id");
    var target = $(".bp-wrapper__container");
    target.find("#swatch-" + id).trigger("click");
  });

  $(".pd-wrapper__images, .pd-wrapper__images-modal").on(
    "slid.bs.carousel",
    function () {
      var id = $(this).find(".carousel-item.active").attr("data-id");
      var target = $(".bp-wrapper__container, .product__info-container");
      target.find("#swatch-" + id).trigger("click");
      var colorSelected = target
        .find("#swatch-" + id)
        .closest(".swatch-element")
        .data("color");
      var oldColor = localStorage.getItem("product_color");
      $("body").removeClass(oldColor).addClass(colorSelected);
      localStorage.setItem("product_color", colorSelected);
    }
  );

  $(".contact-us-text .contact-accordian, .product-faqs .faqs-accordian").on(
    "click",
    function () {
      $(this).siblings().find(".accordion-button").addClass("collapsed");
      $(this).siblings().find(".accordion-collapse").removeClass("show");
    }
  );

  $(".sticky-join-the-waitlist").on("click", function () {
    $(".product__info-container .join-waitlist").trigger("click");
  });

  $(".sticky-add-to-basket").on("click", function () {
    $(".product__info-container .add-to-basket").trigger("click");
  });

  $(".faqs-opener").on("click", function () {
    $(this).siblings().removeClass("open");
    var id = $(this).attr("data-id");
    $(".faqs-type-" + id)
      .siblings()
      .hide();
    $(this).toggleClass("open");
    $(".faqs-type-" + id).toggle();
  });

  $("#shopify-section-faqs #sticky-sidebar button").on("click", function () {
    $(this).addClass("active").siblings().removeClass("active");
  });

  // Klaviyo Form
  $(".klaviyo_submit_button").on("click", function () {
    var email = $("#email_signup #k_id_email").val();
    if (email.length <= 0) {
      $(".klaviyo_messages .success_message").hide();
    }
  });

  KlaviyoSubscribe.attachToForms("#email_signup", {
    hide_form_on_success: false,
    success_message: "Thank you for subscribing!",
  });

  // Subscription navigation
  $("#get-started .subscription").each(function (e) {
    if (e != 0) $(this).hide();
  });

  $(".next").click(function () {
    if ($("#get-started .subscription:visible").next().length != 0)
      $("#get-started .subscription:visible").next().show().prev().hide();
    else {
      $("#get-started .subscription:visible").hide();
      $("#get-started .subscription:first").show();
    }
    return false;
  });

  $(".previous").click(function () {
    if ($("#get-started .subscription:visible").prev().length != 0)
      $("#get-started .subscription:visible").prev().show().next().hide();
    else {
      $("#get-started .subscription:visible").hide();
      $("#get-started .subscription:last").show();
    }
    return false;
  });

  // Quick guide tabs
  var quickGuideActiveIndex = $(".quick-guide-tabs .active-tab").index(),
    $quickGuideContentLis = $(".quick-guide-tabs .tabs-content li"),
    $quickGuideTabsLis = $(".quick-guide-tabs .tabs li");

  $quickGuideContentLis.eq(quickGuideActiveIndex).show();

  $(".quick-guide-tabs .tabs").on("click", "li", function (e) {
    var $current = $(e.currentTarget),
      index = $current.index();

    $quickGuideTabsLis.removeClass("active-tab");
    $current.addClass("active-tab");
    var $current2 = $(this).data("id");
    console.log($current2);
    if ($current2 == 1) {
      $(".product-quick-guide .tabs-content li").hide();
      $(".product-quick-guide .tabs-content .review-tab").show();
    } else {
      $(".product-quick-guide .tabs-content li").hide();
      $(".product-quick-guide .tabs-content .faqs-tab").show();
    }
  });

  // Product details overview tabs
  var productDetailsActiveIndex = $(
    ".product_details_overview .active-tab"
  ).index(),
    $productDetailsContentLis = $(".product_details_overview .tabs-content li"),
    $productDetailsTabsLis = $(".product_details_overview .tabs li");

  $productDetailsContentLis.eq(productDetailsActiveIndex).show();

  $(".product_details_overview .tabs").on("click", "li", function (e) {
    var $current = $(e.currentTarget),
      index = $current.index();

    $productDetailsTabsLis.removeClass("active-tab");
    $current.addClass("active-tab");
    var $current3 = $(this).data("id");
    console.log($current3);
    if ($current3 == 1) {
      $(".product_details_overview .tabs-content li").hide();
      $(".product_details_overview .tabs-content .overview_tab").show();
    } else {
      $(".product_details_overview .tabs-content li").hide();
      $(".product_details_overview .tabs-content .description_tab").show();
    }
  });

  if ($("body").hasClass("template-standalone")) {
    var color_selected = $(".product__info-wrapper .pd-swatch-radio:checked")
      .closest(".swatch-element")
      .data("color");
    localStorage.setItem("product_color", color_selected);
    $("body").addClass(color_selected);
  }

  $(".product__info-wrapper .swatch-element label").click(function () {
    console.log("rafun");
    var old_color = localStorage.getItem("product_color");
    $("body").removeClass(old_color);
    var color_selected = $(this).closest(".swatch-element").data("color");
    localStorage.setItem("product_color", color_selected);
    $("body").addClass(color_selected);
  });

  $("#productCarouselBlack .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".black-prev"),
    nextArrow: $(".black-next"),
    asNavFor: "#navigationProductCarouselBlack .navigation-slider",
  });

  $("#productCarouselBlackPopup .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".black-control-prev"),
    nextArrow: $(".black-control-next"),
    asNavFor: "#productCarouselBlack .product-main-slider",
  });

  $("#navigationProductCarouselBlack .navigation-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-main-slider.black-slider",
    dots: false,
    focusOnSelect: true,
    arrows: false,
  });

  $("#productCarouselBlue .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".blue-prev"),
    nextArrow: $(".blue-next"),
    asNavFor: "#navigationProductCarouselBlue .navigation-slider",
  });

  $("#productCarouselBluePopup .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".blue-control-prev"),
    nextArrow: $(".blue-control-next"),
    asNavFor: "#productCarouselBlue .product-main-slider",
  });

  $("#navigationProductCarouselBlue .navigation-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-main-slider.blue-slider",
    dots: false,
    focusOnSelect: true,
    arrows: false,
  });

  $("#productCarouselPink .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".pink-prev"),
    nextArrow: $(".pink-next"),
    asNavFor: "#navigationProductCarouselPink .navigation-slider",
  });

  $("#productCarouselPinkPopup .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".pink-control-prev"),
    nextArrow: $(".pink-control-next"),
    asNavFor: "#productCarouselPink .product-main-slider",
  });

  $("#navigationProductCarouselPink .navigation-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-main-slider.pink-slider",
    dots: false,
    focusOnSelect: true,
    arrows: false,
  });

  $("#productCarouselRed .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".red-prev"),
    nextArrow: $(".red-next"),
    asNavFor: "#navigationProductCarouselRed .navigation-slider",
  });

  $("#productCarouselRedPopup .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".red-control-prev"),
    nextArrow: $(".red-control-next"),
    asNavFor: "#productCarouselRed .product-main-slider",
  });

  $("#navigationProductCarouselRed .navigation-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-main-slider.red-slider",
    dots: false,
    focusOnSelect: true,
    arrows: false,
  });

  $("#productCarouselMint .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".mint-prev"),
    nextArrow: $(".mint-next"),
    asNavFor: "#navigationProductCarouselMint .navigation-slider",
  });

  $("#productCarouselMintPopup .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".mint-control-prev"),
    nextArrow: $(".mint-control-next"),
    asNavFor: "#productCarouselMint .product-main-slider",
  });

  $("#navigationProductCarouselMint .navigation-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-main-slider.mint-slider",
    dots: false,
    focusOnSelect: true,
    arrows: false,
  });

  $("#productCarouselYellow .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $(".yellow-prev"),
    nextArrow: $(".yellow-next"),
    fade: true,
    asNavFor: "#navigationProductCarouselYellow .navigation-slider",
  });

  $("#productCarouselYellowPopup .product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".yellow-control-prev"),
    nextArrow: $(".yellow-control-next"),
    asNavFor: "#productCarouselYellow .product-main-slider",
  });

  $("#navigationProductCarouselYellow .navigation-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-main-slider.yellow-slider",
    dots: false,
    focusOnSelect: true,
    arrows: false,
  });

  $(".navProductCarousel").hide();
  $(".productCarousel").hide();

  if ($("body").hasClass("Black")) {
    $("#navigationProductCarouselBlack").show();
    $("#productCarouselBlack").show();
    $("#productCarouselBlackPopup").show();
  }

  if ($("body").hasClass("Blue")) {
    $("#navigationProductCarouselBlue").show();
    $("#productCarouselBlue").show();
    $("#productCarouselBluePopup").show();
  }

  if ($("body").hasClass("Red")) {
    $("#navigationProductCarouselRed").show();
    $("#productCarouselRed").show();
    $("#productCarouselRedPopup").show();
  }

  if ($("body").hasClass("Pink")) {
    $("#navigationProductCarouselPink").show();
    $("#productCarouselPink").show();
    $("#productCarouselPinkPopup").show();
  }

  if ($("body").hasClass("Mint")) {
    $("#navigationProductCarouselMint").show();
    $("#productCarouselMint").show();
    $("#productCarouselMintPopup").show();
  }

  if ($("body").hasClass("Yellow")) {
    $("#navigationProductCarouselYellow").show();
    $("#productCarouselYellow").show();
    $("#productCarouselYellowPopup").show();
  }

  $("body").css("opacity", "1");

  $(".swatch-element").click(function () {
    var color = $(this).data("color");
    $(".navProductCarousel").hide();
    $(".productCarousel").hide();
    $("#productCarouselPopup").hide();
    $("#navigationProductCarousel" + color).show();
    $("#productCarousel" + color).show();
    $("#productCarousel" + color + "Popup").show();
  });

  $(".ds_label.ds_placeholder").click(function () {
    $("ul.ds_list").toggle();
  });

  $("ul.ds_list li a").click(function () {
    $("ul.ds_list li a").removeClass("bold-text");
    $(this).addClass("bold-text");
    var sub_val = $(this).data("value");
    var price = $(this).data("price");
    var sellingplan = $(this).data("sellingplan");

    var txt = $(this).html();
    //  $('.product-price').html(price);
    $(
      ".product__info-wrapper .price__container .price-item.price-item--regular"
    ).html(price);
    $(this)
      .closest(".product__info-wrapper")
      .find(".add-to-basket")
      .attr("data-sellingplan", sellingplan);

    $(".product__info-wrapper .selection_box .radio_selection").removeClass(
      "active"
    );
    $(
      '.product__info-wrapper .selection_box .radio_selection[data-value="' +
      sub_val +
      '"]'
    ).addClass("active");
    $(
      '.product__info-wrapper .selection_box .radio_selection[data-value="' +
      sub_val +
      '"]'
    ).trigger("click");
    $(".ds_label.ds_placeholder").html(
      txt +
      '<img src="//cdn.shopify.com/s/files/1/1301/9399/t/310/assets/black-drop-arrow.svg?v=8415716489654561601" class="drop-icon">'
    );
    $("ul.ds_list").toggle();
  });

  $(".yearly.option_selection").click(function () {
    if ($(this).hasClass("active")) {
      if (!$(this).hasClass("yearly-active")) {
        $(
          '.product__info-wrapper .selection_box .radio_selection[data-value="3"]'
        ).trigger("click");
        var price = $('ul.ds_list li a[data-value="3"]').data("price");
        var txt = $('ul.ds_list li a[data-value="3"]').html();
        $("ul.ds_list li a").removeClass("bold-text");
        $('ul.ds_list li a[data-value="3"]').addClass("bold-text");
        var sellingplan = $('ul.ds_list li a[data-value="3"]').data(
          "sellingplan"
        );

        $(this)
          .closest(".product__info-wrapper")
          .find(".add-to-basket")
          .attr("data-sellingplan", sellingplan);
        $(
          ".product__info-wrapper .price__container .price-item.price-item--regular"
        ).html(price);
        $(".ds_label.ds_placeholder").html(
          txt +
          '<img src="//cdn.shopify.com/s/files/1/1301/9399/t/310/assets/black-drop-arrow.svg?v=8415716489654561601" class="drop-icon">'
        );
        $(this).addClass("yearly-active");
      } else {
        var price = $("ul.ds_list li a.bold-text").data("price");
        $(
          ".product__info-wrapper .price__container .price-item.price-item--regular"
        ).html(price);
      }
    }
  });

  $(".one_time").click(function () {
    if ($(this).hasClass("active")) {
      $("ul.ds_list").hide();
    }
  });

  var url = window.location.href;
  var arr = url.split("variant=");
  var vari = arr[1];
  var title = $("input[value=" + vari + "]").data("product");
  if (title) {
    if (title.indexOf("month-plan") >= 0) {
      var color = $("input[value=" + vari + "]").data("title");
      $('.swatch-element[data-color="' + color + '"]').trigger("click");
      $('.swatch-element[data-color="' + color + '"] label').trigger("click");
      $('.swatch-element[data-color="' + color + '"] input').trigger("click");
      var old_color = localStorage.getItem("product_color");
      $("body").removeClass(old_color);
      localStorage.setItem("product_color", color);
      $("body").addClass(color);
    }
  }

  if ($("body").hasClass("template-standalone")) {
    var faqs = $(".faqs-accordian").length;
    $(".number_of_faqs").text("(" + faqs + ")");
  }

  jQuery.fn.random = function () {
    var randomIndex = Math.floor(Math.random() * this.length);
    return jQuery(this[randomIndex]);
  };

  $(".shop_megamenu .mega-menu-product-card").each(function () {
    $(this).find(".mega-menu-img").random().removeClass("mega-menu-img");
  });

  if (
    $("#activeProduct").val() == "flat-body-scrubber" ||
    $("#activeProduct").val() == "face-scrubber" ||
    $("#activeProduct").val() == "loop-body-scrubber"
  ) {
    $(".related-products-standalone .hook")
      .show()
      .removeClass("product-card-temp");
    $(".related-products-standalone .product-card-temp")
      .random()
      .show()
      .removeClass("product-card-temp");
    $(".related-products-standalone .product-card-temp")
      .random()
      .show()
      .removeClass("product-card-temp");
  } else {
    $(".related-products-standalone .hook")
      .hide()
      .removeClass("product-card-temp");
    $(".related-products-standalone .product-card-temp")
      .random()
      .show()
      .removeClass("product-card-temp");
    $(".related-products-standalone .product-card-temp")
      .random()
      .show()
      .removeClass("product-card-temp");
    $(".related-products-standalone .product-card-temp")
      .random()
      .show()
      .removeClass("product-card-temp");
  }

  $(".card.product-card").each(function () {
    $(this).find(".yes_has").random().trigger("click");
  });

  var reviewNumbers = $("span.review-numbers").html();
  var withcommas = addCommas(reviewNumbers);
  $("span.review-numbers").html(withcommas);
  $("span.review-numbers").removeClass("d-none");

  $(".pd-swatch-radio").change(function () {
    var variableVal = $(this).val();
    var urlTemp = window.location.href;
    const myArray = urlTemp.split("?variant");
    var url = myArray[0];
    var completeURL = url + "?variant=" + variableVal;
    window.history.pushState("data", "Title", completeURL);
  });

  $(".product-info-box .active_bundle .swatch").each(function () {
    var target = '"' + $(this).data("target") + '"';
    var uniqueRandoms = [];
    var numRandoms = 5;
    function makeUniqueRandom() {
      // refill the array if needed
      if (!uniqueRandoms.length) {
        for (var i = 0; i < numRandoms; i++) {
          uniqueRandoms.push(i);
        }
      }
      var index = Math.floor(Math.random() * uniqueRandoms.length);
      var val = uniqueRandoms[index];

      // now remove that value from the array
      uniqueRandoms.splice(index, 1);

      return val;
    }
    var rndInt = makeUniqueRandom();
    //     alert(rndInt)
    //change color name under the swatch
    var swatch_name = $(this).find(".swatch-name").text();
    $("#preview-" + $(this).data("target") + " .swatch-name").text(swatch_name);
    if (
      $(this).data("target") == "flat-body-scrubber" ||
      $(this).data("mainproduct") == "loop-body-scrubber"
    ) {
      $("#preview-body-scrubber .swatch-name").text(swatch_name);
    }
    // $('[data-target='+target+'] [data-available="true"]').each(function(index){
    $("[data-target=" + target + "] [data-available]").each(function (index) {
      var index_new = index;
      if (rndInt == index_new) {
        //         $(this).children('input[type="radio"]').prop("checked", true);
        if ($(this).children('input[type="radio"]').prop("checked") == true) {
          $(this).children('input[type="radio"]').trigger("change");
        } else {
          $(this).children("label").trigger("click");
        }
      }
      console.log("inner_loop");
    });
  });
  $(".preview-imgs-block .preview-img").each(function (index) {
    if (index == 0) {
      $(this).trigger("click");
    }
  });

  $(".bp-wrapper .swatch .swatch-element").click(function () {
    let color = $(this).data("colorcode");
    let product = $(this).data("mainproduct");
    //let templateClass = $(this).closest('.template-hook_bundle, .template-bundle, .template-toothbrush_head, .template-bundle_combine, .template-new_body_bundle').attr('class').split(' ')[0];
    updateBackground(".tab-color", product, color);
  });

  $(".preview-img").click(function () {
    if (!$(this).hasClass("active")) {
      $(".preview-img.active").removeClass("active");
      $(this).addClass("active");
    }
    var productClick = $(this).data("handle");
    $(".product-info-box").removeClass("tab-view");
    $(".product-info-box").addClass("tab-none");
    $(".product-" + productClick).addClass("tab-view");
    $(".product-" + productClick).removeClass("tab-none");
    $(".single-slider").removeClass("tab-view");
    $(".single-slider").addClass("tab-none");
    $("." + productClick + "-slider").addClass("tab-view");
    $("." + productClick + "-slider").removeClass("tab-none");
  });
  $(".bp-wrapper .bundle-group__list li").click(function () {
    var product = $(this).find(".bundle_group_product").data("product");
    var slider_id = "ProductCarousel" + product;
    if (product == "flat-body-scrubber" || product == "loop-body-scrubber") {
      var preview_img = "#preview-body-scrubber";
      var fineb = $("#" + slider_id + " .carousel-item.active img").attr("src");
      if ($(window).width() > 767) {
        if (fineb.indexOf(".jpg") >= 0) {
          fineb = fineb.replace(".jpg", "_x106.jpg");
        }
        if (fineb.indexOf(".png") >= 0) {
          fineb = fineb.replace(".png", "_x106.png");
        }
      }
      $(preview_img + " img").attr("src", fineb);
      var color = $(".hr-colors#" + product + " input[type='radio']:checked")
        .parent(".swatch-element")
        .data("colorcode");
      var color_name = $(
        ".hr-colors#" + product + " input[type='radio']:checked"
      )
        .parent(".swatch-element")
        .data("color");
      $("#ColorForGradient-body-scrubber").val(color);
      var bgtemp = "";
      var bgmain = "";
      $(".ForGradient").each(function () {
        var gradient = $(this).val();
        bgtemp = bgtemp + "," + gradient;
        bgmain = bgmain + "," + gradient + "99";
      });
      if ($(window).width() > 1100) {
        var bgcolor = "linear-gradient(to right" + bgtemp + ")";
        var bgmaincolor = "linear-gradient(to right" + bgmain + ")";
      } else {
        if ($(window).width() < 768) {
          var bgcolor = "linear-gradient(45deg" + bgtemp + ")";
          var bgmaincolor = "linear-gradient(45deg" + bgmain + ")";
        } else {
          var bgcolor = "linear-gradient(135deg" + bgtemp + ")";
          var bgmaincolor = "linear-gradient(135deg" + bgmain + ")";
        }
      }
      $(".tab-color").css("background", bgcolor);
      // $('main').css('background', bgmaincolor);
      $("body").removeClass("red black yellow mint pink blue");
      $("body").addClass(color_name);
    } else {
      var preview_img = "#preview-" + slider_handle;
      var fineb = $("#" + slider_id + " .carousel-item.active img").attr("src");
      if ($(window).width() > 767) {
        if (fineb.indexOf(".jpg") >= 0) {
          fineb = fineb.replace(".jpg", "_x106.jpg");
        }
        if (fineb.indexOf(".png") >= 0) {
          fineb = fineb.replace(".png", "_x106.png");
        }
      }
      $(preview_img + " img").attr("src", fineb);
    }
    //   alert(product);
  });

  //Enable swiping...
  $(".slater-product__images.single-slider").swipe({
    //Generic swipe handler for all directions
    swipeRight: function (
      event,
      direction,
      distance,
      duration,
      fingerCount,
      fingerData
    ) {
      event.preventDefault();
      var slider = $(this).data("previous");
      $("#preview-" + slider).trigger("click");
    },
    swipeLeft: function (
      event,
      direction,
      distance,
      duration,
      fingerCount,
      fingerData
    ) {
      event.preventDefault();
      var slider = $(this).data("next");
      $("#preview-" + slider).trigger("click");
    },
  });
  var bgtemp = "";
  $(".bgGradient").each(function () {
    var gradient = $(this).val();
    bgtemp = bgtemp + "," + gradient;
  });
  //here on load
  var bgcolor = "linear-gradient(to right" + bgtemp + ")";

  $(".bp-wrapper .swatch .swatch-element input:checked").each(function () {
    let $parentElement = $(this).closest(".swatch-element");
    let color = $parentElement.data("colorcode");
    let product = $parentElement.data("mainproduct");
    console.log(product, color);
    updateBackground(".tab-color", product, color);
  });

  //  $('.tab-color').css('background', bgcolor);

  var count = 0;
  var packValue = $("#packValue").val();
  $(".pack-counter-btn .js-counter-add").click(function () {
    $(this).closest(".variant-box").find(".add-pack").trigger("click");
  });
  $(".pack-counter-btn .js-counter--remove").click(function (e) {
    e.preventDefault();
    var varID = $(this).closest(".pack-counter-btn").data("id");
    var target_hidden = $(
      '.selection-box .variantID[value="' + varID + '"]'
    ).last();
    target_hidden.siblings(".oval").trigger("click");
  });
  $(".add-pack").click(function () {
    count = count + 1;
    $(this).siblings(".pack-counter-btn").show();
    $(this).hide();
    $(".thumbnail-cta-wrapper").removeClass("cta-center");
    if (count >= packValue) {
      $(".add-pack").addClass("disable-btn");
      $(".add-pack").prop("disabled", true);
      $(".pack-counter-btn").addClass("disable-btn");
      $(".pack-counter-btn .js-counter-add").prop("disabled", true);
      $(".add-to-cart-family").removeClass("disable");
      $(".add-to-cart-family").prop("disabled", false);
      $(".add-to-cart-family").text("ADD TO CART");
    } else {
      if (packValue - count == packValue) {
        $(".selection-box").removeClass("partial-fill");
        $(".add-to-cart-family").text("CHOOSE YOUR COLORS");
        $(".add-to-cart-family").removeClass("disable");
      } else {
        $(".selection-box").addClass("partial-fill");
        $(".add-to-cart-family").addClass("disable");
        if (packValue - count == 1) {
          $(".add-to-cart-family").text(
            "CHOOSE " + (packValue - count) + " MORE COLOR"
          );
        } else {
          $(".add-to-cart-family").text(
            "CHOOSE " + (packValue - count) + " MORE COLORS"
          );
        }
      }
    }
    var bgtemp = "";
    var img = $(this).data("box");
    //     if($(window).width() > 767){
    //       if(img.indexOf(".jpg") >= 0){
    //         img=img.replace(".jpg", "_99x.jpg");
    //       }
    //       if(img.indexOf(".png") >= 0){
    //         img=img.replace(".png", "_99x.png");
    //       }
    //     }
    var color = $(this).data("colorcode");
    var id = $(this).data("id");
    var swatch_name = "color: " + $(this).data("colorname");
    $(".empty.selection-box").each(function () {
      $(this).addClass("selected-box");
      $(this).find("img").attr("src", img);
      $(this).removeClass("empty");
      $(this).find(".bgGradient").val(color);
      $(this).find(".variantID").val(id);
      $(this).find(".swatch-name").text(swatch_name);
      return false;
    });
    $(".bgGradient").each(function () {
      var gradient = $(this).val();
      bgtemp = bgtemp + "," + gradient;
    });
    if ($(window).width() > 1100) {
      var bgcolor = "linear-gradient(to right" + bgtemp + ")";
    } else {
      if ($(window).width() < 768) {
        var bgcolor = "linear-gradient(45deg" + bgtemp + ")";
      } else {
        var bgcolor = "linear-gradient(135deg" + bgtemp + ")";
      }
    }
    // $('.container--l.mxa').css('background',bgcolor);
    // change bg gradient of thumbnail + CTA banner
    if ($(window).width() > 1024) {
      $(".thumbnail-cta-wrapper").css("background", bgcolor);
    } else {
      $(".thumbnail-cta-wrapper .selected-boxes-btn").css(
        "background",
        bgcolor
      );
    }
  });
  $(".oval").click(function () {
    //     alert(count);
    count = count - 1;
    //     alert(count);
    if (packValue - count == packValue) {
      $(".selection-box").removeClass("partial-fill");
      $(".add-to-cart-family").text("CHOOSE YOUR COLORS");
      $(".add-to-cart-family").removeClass("disable");
      $(".thumbnail-cta-wrapper").addClass("cta-center");
    } else {
      $(".selection-box").addClass("partial-fill");
      $(".add-to-cart-family").addClass("disable");
      if (packValue - count == 1) {
        $(".add-to-cart-family").text(
          "CHOOSE " + (packValue - count) + " MORE COLOR"
        );
      } else {
        $(".add-to-cart-family").text(
          "CHOOSE " + (packValue - count) + " MORE COLORS"
        );
      }
    }
    $(".add-to-cart-family").prop("disabled", true);
    $(".add-pack").removeClass("disable-btn");
    $(".add-pack").prop("disabled", false);
    $(".pack-counter-btn").removeClass("disable-btn");
    $(".pack-counter-btn .js-counter-add").prop("disabled", false);
    // decrease value of pack counter
    var varId = $(this).parent(".selection-box").find(".variantID").val();
    var counter_target = $('.pack-counter-btn[data-id="' + varId + '"]');
    var quantity = counter_target.find(".js-counter-quantity").val();
    quantity = parseInt(quantity) - 1;
    if (quantity == 0) {
      counter_target.hide();
      counter_target.siblings(".add-pack").show();
    }
    quantity = quantity > 0 ? quantity : 1;
    counter_target.find(".js-counter-quantity").val(quantity);

    var bgtemp = "";
    var box = $(this).parent(".selection-box");
    box.removeClass("selected-box");
    box.addClass("empty");
    box.find(".bgGradient").val("#fff");
    box.find(".variantID").val("");
    box.find("img").attr("src", "");
    box.find(".swatch-name").text("");
    $(".bgGradient").each(function () {
      var gradient = $(this).val();
      bgtemp = bgtemp + "," + gradient;
    });
    if ($(window).width() > 1100) {
      var bgcolor = "linear-gradient(to right" + bgtemp + ")";
    } else {
      if ($(window).width() < 768) {
        var bgcolor = "linear-gradient(45deg" + bgtemp + ")";
      } else {
        var bgcolor = "linear-gradient(135deg" + bgtemp + ")";
      }
    }
    // $('.container--l.mxa').css('background',bgcolor);
    // change bg gradient of thumbnail + CTA banner
    if ($(window).width() > 1024) {
      $(".thumbnail-cta-wrapper").css("background", bgcolor);
    } else {
      $(".thumbnail-cta-wrapper .selected-boxes-btn").css(
        "background",
        bgcolor
      );
    }
  });
  $(".add-to-cart-family").click(function () {
    var product = $("#productFamily").val();
    var bundleItems = [];
    var familyPack = [];
    var bundleId = Date.now();
    $(".selection-box.selected-box").each(function (index) {
      var variant_id = $(this).find(".variantID").val();
      var family_pack = "family_" + index;
      // alert(variant_id + family_pack);

      familyPack.push(variant_id);

      bundleItems.push({
        quantity: 1,
        id: variant_id,
        properties: {
          family_pack: family_pack,
          _Bundle: product,
          _bid: bundleId,
        },
      });
    });

    localStorage.setItem("family", familyPack);
    add_bundle_items(bundleItems);
  });

  $(".family-text .family-pack-collection .ds_select ul.ds_list a").click(
    function () {
      var pack = $(this).data("value");
      $(".family-pack").hide();
      $("." + pack + "-family-pack").show();
      $("." + pack + "-family-pack .variant-img-box").each(function () {
        var num = getRandomArbitrary(1, 100).toFixed();
        $(this).css("order", num);
      });
    }
  );
  $(".variant-img-box").each(function () {
    var num = getRandomArbitrary(1, 100).toFixed();
    $(this).css("order", num);
  });

  $(".promo-text.other_text").click(function () {
    if ($(this).attr("data-href") != "") {
      window.location = $(this).attr("data-href");
    }
  });

  // $('.promo-text').css('opacity', '1'); // fix for only US version
  /* check Geo info then show / hide promo-text & progress bar on Cart drawer */
  // Check if geo cookie exists
  var cookieName = "geo_country_info";
  var cookieValue = null;
  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 30);

  if (
    document.cookie &&
    document.cookie.match(new RegExp(cookieName + "=(.*?)(;|$)"))
  ) {
    // Cookie exists, get cookie value
    cookieValue = decodeURIComponent(RegExp.$1);
    console.log("cookievalue", cookieValue);
    console.log("already geoinfo", cookieValue);
    $(".bar-container").attr("data-country", cookieValue);
    if (cookieValue == "US") {
      $(".promo-text.us_text").show();
      $(".promo-text.other_text").hide();
      $(".bar-container").show();
      $(".promo-text").css("opacity", "1");
    } else {
      $(".promo-text.us_text").hide();
      $(".promo-text.other_text").show();
      $(".bar-container").hide();
      $(".promo-text").css("opacity", "1");
    }
  } else {
    console.log("no geoinfocookie");
    $.get(
      "https://ipinfo.io",
      function (response) {
        console.log("getgeoinfo", response);
        cookieValue = response.country;
        document.cookie =
          cookieName +
          "=" +
          encodeURIComponent(cookieValue) +
          ";expires=" +
          expirationDate.toUTCString() +
          ";path=/";
        $(".bar-container").attr("data-country", response.country);
        if (response.country == "US") {
          $(".promo-text.us_text").show();
          $(".promo-text.other_text").hide();
          $(".bar-container").show();
          $(".promo-text").css("opacity", "1");
        } else {
          $(".promo-text.us_text").hide();
          $(".promo-text.other_text").show();
          $(".bar-container").hide();
          $(".promo-text").css("opacity", "1");
        }
      },
      "jsonp"
    );
  }

  $(".userNumBar").css("opacity", "1");
  if ($("#numberAreaTotal").length > 0) {
    var counterNum = $("#numberAreaTotal").val();
    counterControl($(".userNumBar"), counterNum);
  }
});

$(document).ready(function () {
  var time = 200;
  $(".v-img-box").each(function (index) {
    var variant = $(this);
    setTimeout(function () {
      variant.addClass("animate");
    }, time);
    time += 200;
  });

  // remove line item in Cart Drawer
  $(document).on(
    "click",
    "#CartDrawer-CartItems .cart-item-remove",
    function (e) {
      e.preventDefault();
      // var item_id = $(this).attr('data-remove-id');
      // var update_data = { updates: {} };
      // update_data.updates[item_id] = 0;
      // $.ajax({
      //   type: 'POST',
      //   url: '/cart/update.js',
      //   data: update_data,
      //   dataType: 'json',
      //   success: function (data) {
      //     get_cart_details();
      //   }
      // });
      var line = $(this).closest(".cart-item").attr("data-line");
      update_cart_items(line, 0);
    }
  );

  var addFreeItem = function (data) {
    if (data.items_subtotal_price >= 5000) {
      if ($(".cart-drawer #CartDrawer-CartItems .cart-item.free-item").length) {
        var freeTarget = $(
          ".cart-drawer #CartDrawer-CartItems .cart-item.free-item"
        )[0];
        $.getJSON(
          "/products/" + $(freeTarget).attr("data-handle") + ".js",
          function (product) {
            let swatches = "";
            const product_id = product["id"];
            const product_variants = product["variants"];
            const pv = [];
            const colors = ["Black", "Blue", "Pink", "Red", "Mint", "Yellow"];
            $.each(colors, function (index, color) {
              $.each(product_variants, function (index, variant) {
                if (color === variant["title"]) {
                  pv.push(variant);
                }
              });
            });
            $.each(pv, function (index, variant) {
              var unique = makeid();
              if (variant["available"]) {
                const variant_id = variant["id"];
                const variant_color = variant["title"];
                const color = variant_color.toLowerCase();
                var variant_image = variant["featured_image"]["src"];
                if ($(window).width() > 767) {
                  if (variant_image.indexOf(".jpg") >= 0) {
                    variant_image = variant_image.replace(".jpg", ".jpg");
                  }
                  if (variant_image.indexOf(".png") >= 0) {
                    variant_image = variant_image.replace(".png", ".png");
                  }
                }
                let checked =
                  $(freeTarget).attr("data-variant-title") === variant_color
                    ? "checked"
                    : "";
                let bundlehandle = "";
                swatches =
                  swatches +
                  '<div class="swatch-color" id="' +
                  bundlehandle +
                  "cartItemVariantId-" +
                  variant_id +
                  '"><input type="radio" name="' +
                  bundlehandle +
                  "cart-item-option-" +
                  product_id +
                  '" class="swatch_cartitem_radio swatches variation" id="' +
                  bundlehandle +
                  "swatch-cartitem-" +
                  unique +
                  "-" +
                  variant_id +
                  '" value="' +
                  variant_id +
                  '"  data-img="' +
                  variant_image +
                  '" ' +
                  checked +
                  '><label for="' +
                  bundlehandle +
                  "swatch-cartitem-" +
                  unique +
                  "-" +
                  variant_id +
                  '" class="swatch-label bg-' +
                  color +
                  '">' +
                  variant_color +
                  "</label></div>";
              }
            });
            $("#CartDrawer-CartItems .cart-item.free-item .cart-vt").html(
              '<div class="cartItemVariantOptions">' + swatches + "</div>"
            );
          }
        );
      } else {
        var ftbId = 30552281481286;
        var lastItem = $(".cart-drawer .cart-item").first();
        if (lastItem.length) {
          var lastItemVariant = lastItem.attr("data-variant-title");
          if (lastItemVariant == "Blue") ftbId = 30552281514054;
          else if (lastItemVariant == "Pink") ftbId = 30552281579590;
          else if (lastItemVariant == "Red") ftbId = 30552281645126;
          else if (lastItemVariant == "Mint") ftbId = 30552281677894;
          else if (lastItemVariant == "Yellow") ftbId = 30552281710662;
          else ftbId = 30552281481286;
        }
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: 1,
            id: ftbId,
            "properties[Free Item]": "FTB",
          },
          dataType: "json",
          success: function (data) {
            get_cart_details();
          },
        });
      }
    } else {
      if ($(".cart-drawer #CartDrawer-CartItems .cart-item.free-item").length) {
        var freeTarget = $(
          ".cart-drawer #CartDrawer-CartItems .cart-item.free-item"
        )[0];
        var freeItemId = $(freeTarget).attr("data-id");
        var update_data = { updates: {} };
        update_data.updates[freeItemId] = 0;
        console.log(update_data);
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: update_data,
          dataType: "json",
          success: function (data) {
            get_cart_details();
          },
        });
      }
    }
  };

  if ($(".shopify-section.subscription-product").length) {
    $(document).click(function (e) {
      var target = e.target;
      if (
        $(".selection_box .ds_select .ds_list").length &&
        !target.closest(".ds_label") &&
        !target.closest(".ds_list")
      ) {
        if ($(".selection_box .ds_select .ds_list").is(":visible"))
          $(".selection_box .ds_select .ds_list").hide();
      }
    });
  }
  if ($(".standalone_product_contianer").length) {
    if ($(window).width() < 768)
      $(".js-counter-quantity").attr("readonly", "readonly");
  }

  // prev/next button for product slider in bundle collection
  $(document).on(
    "click",
    ".bundle-products-section .product-slider-prev",
    function (e) {
      e.preventDefault();
      var activeView = $(".single-slider.tab-view");
      var prevProduct = activeView.data("previous");
      $("#preview-" + prevProduct).trigger("click");
    }
  );
  $(document).on(
    "click",
    ".bundle-products-section .product-slider-next",
    function (e) {
      e.preventDefault();
      var activeView = $(".single-slider.tab-view");
      var nextProduct = activeView.data("next");
      $("#preview-" + nextProduct).trigger("click");
    }
  );
});
